import { baseApi as api } from "../baseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getV2AdminIntakeHubDefinitions: build.query<
      GetV2AdminIntakeHubDefinitionsApiResponse,
      GetV2AdminIntakeHubDefinitionsApiArg
    >({
      query: () => ({ url: `/v2/admin/intake-hub/definitions` }),
    }),
    putV2AdminIntakeHubDefinitionsRequirementsByRequirementKey: build.mutation<
      PutV2AdminIntakeHubDefinitionsRequirementsByRequirementKeyApiResponse,
      PutV2AdminIntakeHubDefinitionsRequirementsByRequirementKeyApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/intake-hub/definitions/requirements/${queryArg.requirementKey}`,
        method: "PUT",
        body: queryArg.upsertIntakeHubRequirementDefinitionRequest,
      }),
    }),
    putV2AdminIntakeHubDefinitionsServicesByServiceKey: build.mutation<
      PutV2AdminIntakeHubDefinitionsServicesByServiceKeyApiResponse,
      PutV2AdminIntakeHubDefinitionsServicesByServiceKeyApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/intake-hub/definitions/services/${queryArg.serviceKey}`,
        method: "PUT",
        body: queryArg.upsertIntakeHubServiceDefinitionRequest,
      }),
    }),
    getV2AdminIntakeHubFleet: build.query<
      GetV2AdminIntakeHubFleetApiResponse,
      GetV2AdminIntakeHubFleetApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/intake-hub/fleet`,
        params: {
          page: queryArg.page,
          per_page: queryArg.perPage,
          search: queryArg.search,
          active_only: queryArg.activeOnly,
          sort_by: queryArg.sortBy,
          sort_order: queryArg.sortOrder,
          stage: queryArg.stage,
        },
      }),
    }),
    getV2AdminIntakeHubVerificationQueue: build.query<
      GetV2AdminIntakeHubVerificationQueueApiResponse,
      GetV2AdminIntakeHubVerificationQueueApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/intake-hub/verification-queue`,
        params: {
          page: queryArg.page,
          per_page: queryArg.perPage,
          search: queryArg.search,
          state: queryArg.state,
        },
      }),
    }),
    getV2AdminOrganizationsByOrganizationIdIntakeHubAggregate: build.query<
      GetV2AdminOrganizationsByOrganizationIdIntakeHubAggregateApiResponse,
      GetV2AdminOrganizationsByOrganizationIdIntakeHubAggregateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/intake-hub/aggregate`,
        params: {
          page: queryArg.page,
          per_page: queryArg.perPage,
        },
      }),
    }),
    getV2AdminOrganizationsByOrganizationIdIntakeHubAgreements: build.query<
      GetV2AdminOrganizationsByOrganizationIdIntakeHubAgreementsApiResponse,
      GetV2AdminOrganizationsByOrganizationIdIntakeHubAgreementsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/intake-hub/agreements`,
      }),
    }),
    postV2AdminOrganizationsByOrganizationIdIntakeHubAgreementsRefresh:
      build.mutation<
        PostV2AdminOrganizationsByOrganizationIdIntakeHubAgreementsRefreshApiResponse,
        PostV2AdminOrganizationsByOrganizationIdIntakeHubAgreementsRefreshApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/organizations/${queryArg.organizationId}/intake-hub/agreements/refresh`,
          method: "POST",
        }),
      }),
    postV2AdminOrganizationsByOrganizationIdIntakeHubAgreementsReset:
      build.mutation<
        PostV2AdminOrganizationsByOrganizationIdIntakeHubAgreementsResetApiResponse,
        PostV2AdminOrganizationsByOrganizationIdIntakeHubAgreementsResetApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/organizations/${queryArg.organizationId}/intake-hub/agreements/reset`,
          method: "POST",
        }),
      }),
    getV2AdminOrganizationsByOrganizationIdIntakeHubConfig: build.query<
      GetV2AdminOrganizationsByOrganizationIdIntakeHubConfigApiResponse,
      GetV2AdminOrganizationsByOrganizationIdIntakeHubConfigApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/intake-hub/config`,
        params: {
          user_id: queryArg.userId,
        },
      }),
    }),
    putV2AdminOrganizationsByOrganizationIdIntakeHubConfig: build.mutation<
      PutV2AdminOrganizationsByOrganizationIdIntakeHubConfigApiResponse,
      PutV2AdminOrganizationsByOrganizationIdIntakeHubConfigApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/intake-hub/config`,
        method: "PUT",
        body: queryArg.intakeFormConfigurationUpdateRequest,
        params: {
          user_id: queryArg.userId,
        },
      }),
    }),
    getV2AdminOrganizationsByOrganizationIdIntakeHubCredentialingStatuses:
      build.query<
        GetV2AdminOrganizationsByOrganizationIdIntakeHubCredentialingStatusesApiResponse,
        GetV2AdminOrganizationsByOrganizationIdIntakeHubCredentialingStatusesApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/organizations/${queryArg.organizationId}/intake-hub/credentialing-statuses`,
          params: {
            user_id: queryArg.userId,
            payer_uuid: queryArg.payerUuid,
            status: queryArg.status,
            limit: queryArg.limit,
            offset: queryArg.offset,
          },
        }),
      }),
    postV2AdminOrganizationsByOrganizationIdIntakeHubCredentialingStatuses:
      build.mutation<
        PostV2AdminOrganizationsByOrganizationIdIntakeHubCredentialingStatusesApiResponse,
        PostV2AdminOrganizationsByOrganizationIdIntakeHubCredentialingStatusesApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/organizations/${queryArg.organizationId}/intake-hub/credentialing-statuses`,
          method: "POST",
          body: queryArg.createCredentialingStatusRequest,
        }),
      }),
    deleteV2AdminOrganizationsByOrganizationIdIntakeHubCredentialingStatusesByIdAndCredentialingStatusId:
      build.mutation<
        DeleteV2AdminOrganizationsByOrganizationIdIntakeHubCredentialingStatusesByIdAndCredentialingStatusIdApiResponse,
        DeleteV2AdminOrganizationsByOrganizationIdIntakeHubCredentialingStatusesByIdAndCredentialingStatusIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/organizations/${queryArg.organizationId}/intake-hub/credentialing-statuses/by-id/${queryArg.credentialingStatusId}`,
          method: "DELETE",
        }),
      }),
    getV2AdminOrganizationsByOrganizationIdIntakeHubCredentialingStatusesByIdAndCredentialingStatusId:
      build.query<
        GetV2AdminOrganizationsByOrganizationIdIntakeHubCredentialingStatusesByIdAndCredentialingStatusIdApiResponse,
        GetV2AdminOrganizationsByOrganizationIdIntakeHubCredentialingStatusesByIdAndCredentialingStatusIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/organizations/${queryArg.organizationId}/intake-hub/credentialing-statuses/by-id/${queryArg.credentialingStatusId}`,
        }),
      }),
    patchV2AdminOrganizationsByOrganizationIdIntakeHubCredentialingStatusesByIdAndCredentialingStatusId:
      build.mutation<
        PatchV2AdminOrganizationsByOrganizationIdIntakeHubCredentialingStatusesByIdAndCredentialingStatusIdApiResponse,
        PatchV2AdminOrganizationsByOrganizationIdIntakeHubCredentialingStatusesByIdAndCredentialingStatusIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/organizations/${queryArg.organizationId}/intake-hub/credentialing-statuses/by-id/${queryArg.credentialingStatusId}`,
          method: "PATCH",
          body: queryArg.updateCredentialingStatusRequest,
        }),
      }),
    deleteV2AdminOrganizationsByOrganizationIdIntakeHubCredentialingStatusesAndPayerUuid:
      build.mutation<
        DeleteV2AdminOrganizationsByOrganizationIdIntakeHubCredentialingStatusesAndPayerUuidApiResponse,
        DeleteV2AdminOrganizationsByOrganizationIdIntakeHubCredentialingStatusesAndPayerUuidApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/organizations/${queryArg.organizationId}/intake-hub/credentialing-statuses/${queryArg.payerUuid}`,
          method: "DELETE",
          params: {
            user_id: queryArg.userId,
          },
        }),
      }),
    getV2AdminOrganizationsByOrganizationIdIntakeHubCredentialingStatusesAndPayerUuid:
      build.query<
        GetV2AdminOrganizationsByOrganizationIdIntakeHubCredentialingStatusesAndPayerUuidApiResponse,
        GetV2AdminOrganizationsByOrganizationIdIntakeHubCredentialingStatusesAndPayerUuidApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/organizations/${queryArg.organizationId}/intake-hub/credentialing-statuses/${queryArg.payerUuid}`,
          params: {
            user_id: queryArg.userId,
          },
        }),
      }),
    patchV2AdminOrganizationsByOrganizationIdIntakeHubCredentialingStatusesAndPayerUuid:
      build.mutation<
        PatchV2AdminOrganizationsByOrganizationIdIntakeHubCredentialingStatusesAndPayerUuidApiResponse,
        PatchV2AdminOrganizationsByOrganizationIdIntakeHubCredentialingStatusesAndPayerUuidApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/organizations/${queryArg.organizationId}/intake-hub/credentialing-statuses/${queryArg.payerUuid}`,
          method: "PATCH",
          body: queryArg.updateCredentialingStatusRequest,
          params: {
            user_id: queryArg.userId,
          },
        }),
      }),
    getV2AdminOrganizationsByOrganizationIdIntakeHubDashboard: build.query<
      GetV2AdminOrganizationsByOrganizationIdIntakeHubDashboardApiResponse,
      GetV2AdminOrganizationsByOrganizationIdIntakeHubDashboardApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/intake-hub/dashboard`,
        params: {
          user_id: queryArg.userId,
          experience: queryArg.experience,
        },
      }),
    }),
    getV2AdminOrganizationsByOrganizationIdIntakeHubDocuments: build.query<
      GetV2AdminOrganizationsByOrganizationIdIntakeHubDocumentsApiResponse,
      GetV2AdminOrganizationsByOrganizationIdIntakeHubDocumentsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/intake-hub/documents`,
        params: {
          user_id: queryArg.userId,
          experience: queryArg.experience,
        },
      }),
    }),
    getV2AdminOrganizationsByOrganizationIdIntakeHubDocumentsDownload:
      build.query<
        GetV2AdminOrganizationsByOrganizationIdIntakeHubDocumentsDownloadApiResponse,
        GetV2AdminOrganizationsByOrganizationIdIntakeHubDocumentsDownloadApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/organizations/${queryArg.organizationId}/intake-hub/documents/download`,
          params: {
            user_id: queryArg.userId,
            experience: queryArg.experience,
          },
        }),
      }),
    postV2AdminOrganizationsByOrganizationIdIntakeHubEnrollments:
      build.mutation<
        PostV2AdminOrganizationsByOrganizationIdIntakeHubEnrollmentsApiResponse,
        PostV2AdminOrganizationsByOrganizationIdIntakeHubEnrollmentsApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/organizations/${queryArg.organizationId}/intake-hub/enrollments`,
          method: "POST",
          body: queryArg.enrollServicesRequest,
          params: {
            user_id: queryArg.userId,
          },
        }),
      }),
    postV2AdminOrganizationsByOrganizationIdIntakeHubForm: build.mutation<
      PostV2AdminOrganizationsByOrganizationIdIntakeHubFormApiResponse,
      PostV2AdminOrganizationsByOrganizationIdIntakeHubFormApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/intake-hub/form`,
        method: "POST",
        body: queryArg.generateIntakeFormRequest,
        params: {
          user_id: queryArg.userId,
        },
      }),
    }),
    getV2AdminOrganizationsByOrganizationIdIntakeHubFormPayers: build.query<
      GetV2AdminOrganizationsByOrganizationIdIntakeHubFormPayersApiResponse,
      GetV2AdminOrganizationsByOrganizationIdIntakeHubFormPayersApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/intake-hub/form/payers`,
        params: {
          user_id: queryArg.userId,
          experience: queryArg.experience,
        },
      }),
    }),
    getV2AdminOrganizationsByOrganizationIdIntakeHubHandoff: build.query<
      GetV2AdminOrganizationsByOrganizationIdIntakeHubHandoffApiResponse,
      GetV2AdminOrganizationsByOrganizationIdIntakeHubHandoffApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/intake-hub/handoff`,
        params: {
          user_id: queryArg.userId,
          experience: queryArg.experience,
        },
      }),
    }),
    postV2AdminOrganizationsByOrganizationIdIntakeHubItemsAndIntakeItemIdDocumentReferences:
      build.mutation<
        PostV2AdminOrganizationsByOrganizationIdIntakeHubItemsAndIntakeItemIdDocumentReferencesApiResponse,
        PostV2AdminOrganizationsByOrganizationIdIntakeHubItemsAndIntakeItemIdDocumentReferencesApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/organizations/${queryArg.organizationId}/intake-hub/items/${queryArg.intakeItemId}/document-references`,
          method: "POST",
          body: queryArg.attachDocumentReferenceRequest,
          params: {
            user_id: queryArg.userId,
          },
        }),
      }),
    patchV2AdminOrganizationsByOrganizationIdIntakeHubItemsAndIntakeItemIdEvidence:
      build.mutation<
        PatchV2AdminOrganizationsByOrganizationIdIntakeHubItemsAndIntakeItemIdEvidenceApiResponse,
        PatchV2AdminOrganizationsByOrganizationIdIntakeHubItemsAndIntakeItemIdEvidenceApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/organizations/${queryArg.organizationId}/intake-hub/items/${queryArg.intakeItemId}/evidence`,
          method: "PATCH",
          body: queryArg.updateItemEvidenceRequest,
          params: {
            user_id: queryArg.userId,
          },
        }),
      }),
    putV2AdminOrganizationsByOrganizationIdIntakeHubItemsAndIntakeItemIdSensitiveFields:
      build.mutation<
        PutV2AdminOrganizationsByOrganizationIdIntakeHubItemsAndIntakeItemIdSensitiveFieldsApiResponse,
        PutV2AdminOrganizationsByOrganizationIdIntakeHubItemsAndIntakeItemIdSensitiveFieldsApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/organizations/${queryArg.organizationId}/intake-hub/items/${queryArg.intakeItemId}/sensitive-fields`,
          method: "PUT",
          body: queryArg.updateSensitiveFieldRequest,
          params: {
            user_id: queryArg.userId,
          },
        }),
      }),
    postV2AdminOrganizationsByOrganizationIdIntakeHubMaterialize:
      build.mutation<
        PostV2AdminOrganizationsByOrganizationIdIntakeHubMaterializeApiResponse,
        PostV2AdminOrganizationsByOrganizationIdIntakeHubMaterializeApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/organizations/${queryArg.organizationId}/intake-hub/materialize`,
          method: "POST",
          params: {
            user_id: queryArg.userId,
          },
        }),
      }),
    getV2AdminOrganizationsByOrganizationIdIntakeHubOrgEnrollments: build.query<
      GetV2AdminOrganizationsByOrganizationIdIntakeHubOrgEnrollmentsApiResponse,
      GetV2AdminOrganizationsByOrganizationIdIntakeHubOrgEnrollmentsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/intake-hub/org-enrollments`,
      }),
    }),
    postV2AdminOrganizationsByOrganizationIdIntakeHubOrgEnrollments:
      build.mutation<
        PostV2AdminOrganizationsByOrganizationIdIntakeHubOrgEnrollmentsApiResponse,
        PostV2AdminOrganizationsByOrganizationIdIntakeHubOrgEnrollmentsApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/organizations/${queryArg.organizationId}/intake-hub/org-enrollments`,
          method: "POST",
          body: queryArg.organizationEnrollServicesRequest,
        }),
      }),
    postV2AdminOrganizationsByOrganizationIdIntakeHubProviderRoster:
      build.mutation<
        PostV2AdminOrganizationsByOrganizationIdIntakeHubProviderRosterApiResponse,
        PostV2AdminOrganizationsByOrganizationIdIntakeHubProviderRosterApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/organizations/${queryArg.organizationId}/intake-hub/provider-roster`,
          method: "POST",
          body: queryArg.intakeHubProviderRosterAddRequest,
        }),
      }),
    deleteV2AdminOrganizationsByOrganizationIdIntakeHubProviderRosterAndUserId:
      build.mutation<
        DeleteV2AdminOrganizationsByOrganizationIdIntakeHubProviderRosterAndUserIdApiResponse,
        DeleteV2AdminOrganizationsByOrganizationIdIntakeHubProviderRosterAndUserIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/organizations/${queryArg.organizationId}/intake-hub/provider-roster/${queryArg.userId}`,
          method: "DELETE",
        }),
      }),
    deleteV2AdminOrganizationsByOrganizationIdIntakeHubVerification:
      build.mutation<
        DeleteV2AdminOrganizationsByOrganizationIdIntakeHubVerificationApiResponse,
        DeleteV2AdminOrganizationsByOrganizationIdIntakeHubVerificationApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/organizations/${queryArg.organizationId}/intake-hub/verification`,
          method: "DELETE",
          params: {
            user_id: queryArg.userId,
          },
        }),
      }),
    postV2AdminOrganizationsByOrganizationIdIntakeHubVerification:
      build.mutation<
        PostV2AdminOrganizationsByOrganizationIdIntakeHubVerificationApiResponse,
        PostV2AdminOrganizationsByOrganizationIdIntakeHubVerificationApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/organizations/${queryArg.organizationId}/intake-hub/verification`,
          method: "POST",
          params: {
            user_id: queryArg.userId,
          },
        }),
      }),
    getV2ProviderIntakeHubAgreements: build.query<
      GetV2ProviderIntakeHubAgreementsApiResponse,
      GetV2ProviderIntakeHubAgreementsApiArg
    >({
      query: () => ({ url: `/v2/provider/intake-hub/agreements` }),
    }),
    postV2ProviderIntakeHubAgreementsRefresh: build.mutation<
      PostV2ProviderIntakeHubAgreementsRefreshApiResponse,
      PostV2ProviderIntakeHubAgreementsRefreshApiArg
    >({
      query: () => ({
        url: `/v2/provider/intake-hub/agreements/refresh`,
        method: "POST",
      }),
    }),
    postV2ProviderIntakeHubAgreementsSession: build.mutation<
      PostV2ProviderIntakeHubAgreementsSessionApiResponse,
      PostV2ProviderIntakeHubAgreementsSessionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/intake-hub/agreements/session`,
        method: "POST",
        body: queryArg.docusignSigningSessionRequest,
      }),
    }),
    getV2ProviderIntakeHubBillingIdentitySuggestions: build.query<
      GetV2ProviderIntakeHubBillingIdentitySuggestionsApiResponse,
      GetV2ProviderIntakeHubBillingIdentitySuggestionsApiArg
    >({
      query: () => ({
        url: `/v2/provider/intake-hub/billing-identity-suggestions`,
      }),
    }),
    postV2ProviderIntakeHubBillingIdentitySuggestionsResolve: build.mutation<
      PostV2ProviderIntakeHubBillingIdentitySuggestionsResolveApiResponse,
      PostV2ProviderIntakeHubBillingIdentitySuggestionsResolveApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/intake-hub/billing-identity-suggestions/resolve`,
        method: "POST",
        body: queryArg.intakeBillingIdentitySuggestionResolveRequest,
      }),
    }),
    postV2ProviderIntakeHubBillingStageStatus: build.mutation<
      PostV2ProviderIntakeHubBillingStageStatusApiResponse,
      PostV2ProviderIntakeHubBillingStageStatusApiArg
    >({
      query: () => ({
        url: `/v2/provider/intake-hub/billing-stage/status`,
        method: "POST",
      }),
    }),
    getV2ProviderIntakeHubConfig: build.query<
      GetV2ProviderIntakeHubConfigApiResponse,
      GetV2ProviderIntakeHubConfigApiArg
    >({
      query: () => ({ url: `/v2/provider/intake-hub/config` }),
    }),
    putV2ProviderIntakeHubConfig: build.mutation<
      PutV2ProviderIntakeHubConfigApiResponse,
      PutV2ProviderIntakeHubConfigApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/intake-hub/config`,
        method: "PUT",
        body: queryArg.intakeFormConfigurationProviderUpdateRequest,
      }),
    }),
    getV2ProviderIntakeHubCredentialingStatuses: build.query<
      GetV2ProviderIntakeHubCredentialingStatusesApiResponse,
      GetV2ProviderIntakeHubCredentialingStatusesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/intake-hub/credentialing-statuses`,
        params: {
          user_id: queryArg.userId,
          payer_uuid: queryArg.payerUuid,
          status: queryArg.status,
          limit: queryArg.limit,
          offset: queryArg.offset,
        },
      }),
    }),
    getV2ProviderIntakeHubCredentialingStatusesByIdByCredentialingStatusId:
      build.query<
        GetV2ProviderIntakeHubCredentialingStatusesByIdByCredentialingStatusIdApiResponse,
        GetV2ProviderIntakeHubCredentialingStatusesByIdByCredentialingStatusIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/intake-hub/credentialing-statuses/by-id/${queryArg.credentialingStatusId}`,
        }),
      }),
    getV2ProviderIntakeHubCredentialingStatusesByPayerUuid: build.query<
      GetV2ProviderIntakeHubCredentialingStatusesByPayerUuidApiResponse,
      GetV2ProviderIntakeHubCredentialingStatusesByPayerUuidApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/intake-hub/credentialing-statuses/${queryArg.payerUuid}`,
        params: {
          user_id: queryArg.userId,
        },
      }),
    }),
    getV2ProviderIntakeHubDashboard: build.query<
      GetV2ProviderIntakeHubDashboardApiResponse,
      GetV2ProviderIntakeHubDashboardApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/intake-hub/dashboard`,
        params: {
          experience: queryArg.experience,
          view: queryArg.view,
          subject_user_id: queryArg.subjectUserId,
        },
      }),
    }),
    putV2ProviderIntakeHubDocumentFieldSuggestions: build.mutation<
      PutV2ProviderIntakeHubDocumentFieldSuggestionsApiResponse,
      PutV2ProviderIntakeHubDocumentFieldSuggestionsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/intake-hub/document-field-suggestions`,
        method: "PUT",
        body: queryArg.acceptDocumentFieldSuggestionsRequest,
      }),
    }),
    getV2ProviderIntakeHubDocuments: build.query<
      GetV2ProviderIntakeHubDocumentsApiResponse,
      GetV2ProviderIntakeHubDocumentsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/intake-hub/documents`,
        params: {
          experience: queryArg.experience,
          view: queryArg.view,
          subject_user_id: queryArg.subjectUserId,
        },
      }),
    }),
    getV2ProviderIntakeHubDocumentsDownload: build.query<
      GetV2ProviderIntakeHubDocumentsDownloadApiResponse,
      GetV2ProviderIntakeHubDocumentsDownloadApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/intake-hub/documents/download`,
        params: {
          experience: queryArg.experience,
          view: queryArg.view,
          subject_user_id: queryArg.subjectUserId,
        },
      }),
    }),
    postV2ProviderIntakeHubEnrollments: build.mutation<
      PostV2ProviderIntakeHubEnrollmentsApiResponse,
      PostV2ProviderIntakeHubEnrollmentsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/intake-hub/enrollments`,
        method: "POST",
        body: queryArg.enrollServicesRequest,
      }),
    }),
    postV2ProviderIntakeHubForm: build.mutation<
      PostV2ProviderIntakeHubFormApiResponse,
      PostV2ProviderIntakeHubFormApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/intake-hub/form`,
        method: "POST",
        body: queryArg.generateIntakeFormRequest,
      }),
    }),
    getV2ProviderIntakeHubFormPayers: build.query<
      GetV2ProviderIntakeHubFormPayersApiResponse,
      GetV2ProviderIntakeHubFormPayersApiArg
    >({
      query: () => ({ url: `/v2/provider/intake-hub/form/payers` }),
    }),
    getV2ProviderIntakeHubHandoff: build.query<
      GetV2ProviderIntakeHubHandoffApiResponse,
      GetV2ProviderIntakeHubHandoffApiArg
    >({
      query: () => ({ url: `/v2/provider/intake-hub/handoff` }),
    }),
    postV2ProviderIntakeHubItemsByIntakeItemIdDocumentReferences:
      build.mutation<
        PostV2ProviderIntakeHubItemsByIntakeItemIdDocumentReferencesApiResponse,
        PostV2ProviderIntakeHubItemsByIntakeItemIdDocumentReferencesApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/intake-hub/items/${queryArg.intakeItemId}/document-references`,
          method: "POST",
          body: queryArg.attachDocumentReferenceRequest,
        }),
      }),
    postV2ProviderIntakeHubItemsByIntakeItemIdDocumentsAndDocumentReferenceIdExtractionsExtractionIdFieldsFieldIdAccept:
      build.mutation<
        PostV2ProviderIntakeHubItemsByIntakeItemIdDocumentsAndDocumentReferenceIdExtractionsExtractionIdFieldsFieldIdAcceptApiResponse,
        PostV2ProviderIntakeHubItemsByIntakeItemIdDocumentsAndDocumentReferenceIdExtractionsExtractionIdFieldsFieldIdAcceptApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/intake-hub/items/${queryArg.intakeItemId}/documents/${queryArg.documentReferenceId}/extractions/${queryArg.extractionId}/fields/${queryArg.fieldId}/accept`,
          method: "POST",
          body: queryArg.acceptDocumentFieldSuggestionReviewRequest,
        }),
      }),
    patchV2ProviderIntakeHubItemsByIntakeItemIdEvidence: build.mutation<
      PatchV2ProviderIntakeHubItemsByIntakeItemIdEvidenceApiResponse,
      PatchV2ProviderIntakeHubItemsByIntakeItemIdEvidenceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/intake-hub/items/${queryArg.intakeItemId}/evidence`,
        method: "PATCH",
        body: queryArg.updateItemEvidenceProviderRequest,
      }),
    }),
    putV2ProviderIntakeHubItemsByIntakeItemIdSensitiveFields: build.mutation<
      PutV2ProviderIntakeHubItemsByIntakeItemIdSensitiveFieldsApiResponse,
      PutV2ProviderIntakeHubItemsByIntakeItemIdSensitiveFieldsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/intake-hub/items/${queryArg.intakeItemId}/sensitive-fields`,
        method: "PUT",
        body: queryArg.updateSensitiveFieldRequest,
      }),
    }),
    postV2ProviderIntakeHubMaterialize: build.mutation<
      PostV2ProviderIntakeHubMaterializeApiResponse,
      PostV2ProviderIntakeHubMaterializeApiArg
    >({
      query: () => ({
        url: `/v2/provider/intake-hub/materialize`,
        method: "POST",
      }),
    }),
    getV2ProviderIntakeHubOrgServices: build.query<
      GetV2ProviderIntakeHubOrgServicesApiResponse,
      GetV2ProviderIntakeHubOrgServicesApiArg
    >({
      query: () => ({ url: `/v2/provider/intake-hub/org-services` }),
    }),
    putV2ProviderIntakeHubOrgServices: build.mutation<
      PutV2ProviderIntakeHubOrgServicesApiResponse,
      PutV2ProviderIntakeHubOrgServicesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/intake-hub/org-services`,
        method: "PUT",
        body: queryArg.organizationEnrollServicesRequest,
      }),
    }),
    postV2ProviderIntakeHubProviderRoster: build.mutation<
      PostV2ProviderIntakeHubProviderRosterApiResponse,
      PostV2ProviderIntakeHubProviderRosterApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/intake-hub/provider-roster`,
        method: "POST",
        body: queryArg.intakeHubProviderRosterAddRequest,
      }),
    }),
    deleteV2ProviderIntakeHubProviderRosterByUserId: build.mutation<
      DeleteV2ProviderIntakeHubProviderRosterByUserIdApiResponse,
      DeleteV2ProviderIntakeHubProviderRosterByUserIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/intake-hub/provider-roster/${queryArg.userId}`,
        method: "DELETE",
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type GetV2AdminIntakeHubDefinitionsApiResponse =
  /** status 200 OK */ IntakeHubDefinitionCatalogResponse;
export type GetV2AdminIntakeHubDefinitionsApiArg = void;
export type PutV2AdminIntakeHubDefinitionsRequirementsByRequirementKeyApiResponse =
  /** status 200 OK */ IntakeHubRequirementDefinitionResponse2;
export type PutV2AdminIntakeHubDefinitionsRequirementsByRequirementKeyApiArg = {
  requirementKey: string;
  upsertIntakeHubRequirementDefinitionRequest: UpsertIntakeHubRequirementDefinitionRequest;
};
export type PutV2AdminIntakeHubDefinitionsServicesByServiceKeyApiResponse =
  /** status 200 OK */ IntakeHubServiceDefinitionResponse2;
export type PutV2AdminIntakeHubDefinitionsServicesByServiceKeyApiArg = {
  serviceKey: string;
  upsertIntakeHubServiceDefinitionRequest: UpsertIntakeHubServiceDefinitionRequest;
};
export type GetV2AdminIntakeHubFleetApiResponse =
  /** status 200 OK */ IntakeFleetResponse;
export type GetV2AdminIntakeHubFleetApiArg = {
  /** Page number (1-based) */
  page?: number;
  perPage?: number;
  search?: string;
  activeOnly?: boolean;
  sortBy?: "last_activity" | "name";
  sortOrder?: "asc" | "desc";
  stage?:
    | (
        | "awaiting_verification"
        | "intake_incomplete"
        | "credentialing_in_progress"
        | "ehr_in_progress"
      )
    | null;
};
export type GetV2AdminIntakeHubVerificationQueueApiResponse =
  /** status 200 OK */ IntakeVerificationQueueResponse;
export type GetV2AdminIntakeHubVerificationQueueApiArg = {
  /** Page number (1-based) */
  page?: number;
  perPage?: number;
  search?: string;
  state?: "all" | "awaiting" | "verified" | "incomplete";
};
export type GetV2AdminOrganizationsByOrganizationIdIntakeHubAggregateApiResponse =
  /** status 200 OK */ IntakeHubAggregateResponse;
export type GetV2AdminOrganizationsByOrganizationIdIntakeHubAggregateApiArg = {
  organizationId: string;
  /** Page number (1-based) */
  page?: number;
  perPage?: number;
};
export type GetV2AdminOrganizationsByOrganizationIdIntakeHubAgreementsApiResponse =
  /** status 200 OK */ DocusignAgreementStatusResponse;
export type GetV2AdminOrganizationsByOrganizationIdIntakeHubAgreementsApiArg = {
  organizationId: string;
};
export type PostV2AdminOrganizationsByOrganizationIdIntakeHubAgreementsRefreshApiResponse =
  /** status 200 OK */ DocusignAgreementStatusResponse;
export type PostV2AdminOrganizationsByOrganizationIdIntakeHubAgreementsRefreshApiArg =
  {
    organizationId: string;
  };
export type PostV2AdminOrganizationsByOrganizationIdIntakeHubAgreementsResetApiResponse =
  /** status 200 OK */ DocusignAgreementStatusResponse;
export type PostV2AdminOrganizationsByOrganizationIdIntakeHubAgreementsResetApiArg =
  {
    organizationId: string;
  };
export type GetV2AdminOrganizationsByOrganizationIdIntakeHubConfigApiResponse =
  /** status 200 OK */ IntakeFormConfigurationResponse2;
export type GetV2AdminOrganizationsByOrganizationIdIntakeHubConfigApiArg = {
  organizationId: string;
  userId: string;
};
export type PutV2AdminOrganizationsByOrganizationIdIntakeHubConfigApiResponse =
  /** status 200 OK */ IntakeFormConfigurationResponse2;
export type PutV2AdminOrganizationsByOrganizationIdIntakeHubConfigApiArg = {
  organizationId: string;
  userId: string;
  intakeFormConfigurationUpdateRequest: IntakeFormConfigurationUpdateRequest;
};
export type GetV2AdminOrganizationsByOrganizationIdIntakeHubCredentialingStatusesApiResponse =
  /** status 200 OK */ CredentialingStatusListResponse;
export type GetV2AdminOrganizationsByOrganizationIdIntakeHubCredentialingStatusesApiArg =
  {
    organizationId: string;
    userId?: string | null;
    payerUuid?: string | null;
    status?: IntakeCredentialingStatus2 | null;
    limit?: number;
    offset?: number;
  };
export type PostV2AdminOrganizationsByOrganizationIdIntakeHubCredentialingStatusesApiResponse =
  /** status 201 Created */ IntakeCredentialingStatusRecord2;
export type PostV2AdminOrganizationsByOrganizationIdIntakeHubCredentialingStatusesApiArg =
  {
    organizationId: string;
    createCredentialingStatusRequest: CreateCredentialingStatusRequest;
  };
export type DeleteV2AdminOrganizationsByOrganizationIdIntakeHubCredentialingStatusesByIdAndCredentialingStatusIdApiResponse =
  unknown;
export type DeleteV2AdminOrganizationsByOrganizationIdIntakeHubCredentialingStatusesByIdAndCredentialingStatusIdApiArg =
  {
    organizationId: string;
    credentialingStatusId: string;
  };
export type GetV2AdminOrganizationsByOrganizationIdIntakeHubCredentialingStatusesByIdAndCredentialingStatusIdApiResponse =
  /** status 200 OK */ IntakeCredentialingStatusRecord2;
export type GetV2AdminOrganizationsByOrganizationIdIntakeHubCredentialingStatusesByIdAndCredentialingStatusIdApiArg =
  {
    organizationId: string;
    credentialingStatusId: string;
  };
export type PatchV2AdminOrganizationsByOrganizationIdIntakeHubCredentialingStatusesByIdAndCredentialingStatusIdApiResponse =
  /** status 200 OK */ IntakeCredentialingStatusRecord2;
export type PatchV2AdminOrganizationsByOrganizationIdIntakeHubCredentialingStatusesByIdAndCredentialingStatusIdApiArg =
  {
    organizationId: string;
    credentialingStatusId: string;
    updateCredentialingStatusRequest: UpdateCredentialingStatusRequest;
  };
export type DeleteV2AdminOrganizationsByOrganizationIdIntakeHubCredentialingStatusesAndPayerUuidApiResponse =
  unknown;
export type DeleteV2AdminOrganizationsByOrganizationIdIntakeHubCredentialingStatusesAndPayerUuidApiArg =
  {
    organizationId: string;
    payerUuid: string;
    userId: string;
  };
export type GetV2AdminOrganizationsByOrganizationIdIntakeHubCredentialingStatusesAndPayerUuidApiResponse =
  /** status 200 OK */ IntakeCredentialingStatusRecord2;
export type GetV2AdminOrganizationsByOrganizationIdIntakeHubCredentialingStatusesAndPayerUuidApiArg =
  {
    organizationId: string;
    payerUuid: string;
    userId: string;
  };
export type PatchV2AdminOrganizationsByOrganizationIdIntakeHubCredentialingStatusesAndPayerUuidApiResponse =
  /** status 200 OK */ IntakeCredentialingStatusRecord2;
export type PatchV2AdminOrganizationsByOrganizationIdIntakeHubCredentialingStatusesAndPayerUuidApiArg =
  {
    organizationId: string;
    payerUuid: string;
    userId: string;
    updateCredentialingStatusRequest: UpdateCredentialingStatusRequest;
  };
export type GetV2AdminOrganizationsByOrganizationIdIntakeHubDashboardApiResponse =
  /** status 200 OK */ IntakeHubDashboardResponse;
export type GetV2AdminOrganizationsByOrganizationIdIntakeHubDashboardApiArg = {
  organizationId: string;
  userId?: string | null;
  experience?: "v2" | null;
};
export type GetV2AdminOrganizationsByOrganizationIdIntakeHubDocumentsApiResponse =
  /** status 200 OK */ IntakeHubDocumentInventoryResponse;
export type GetV2AdminOrganizationsByOrganizationIdIntakeHubDocumentsApiArg = {
  organizationId: string;
  userId?: string | null;
  experience?: "v2" | null;
};
export type GetV2AdminOrganizationsByOrganizationIdIntakeHubDocumentsDownloadApiResponse =
  unknown;
export type GetV2AdminOrganizationsByOrganizationIdIntakeHubDocumentsDownloadApiArg =
  {
    organizationId: string;
    userId?: string | null;
    experience?: "v2" | null;
  };
export type PostV2AdminOrganizationsByOrganizationIdIntakeHubEnrollmentsApiResponse =
  /** status 200 OK */ EnrollServicesResponse;
export type PostV2AdminOrganizationsByOrganizationIdIntakeHubEnrollmentsApiArg =
  {
    organizationId: string;
    userId: string;
    enrollServicesRequest: EnrollServicesRequest;
  };
export type PostV2AdminOrganizationsByOrganizationIdIntakeHubFormApiResponse =
  /** status 200 OK */ GenerateIntakeFormResponse2;
export type PostV2AdminOrganizationsByOrganizationIdIntakeHubFormApiArg = {
  organizationId: string;
  userId: string;
  generateIntakeFormRequest: GenerateIntakeFormRequest;
};
export type GetV2AdminOrganizationsByOrganizationIdIntakeHubFormPayersApiResponse =
  /** status 200 OK */ IntakeFormPayerOptionsResponse;
export type GetV2AdminOrganizationsByOrganizationIdIntakeHubFormPayersApiArg = {
  organizationId: string;
  userId?: string | null;
  experience?: "v2" | null;
};
export type GetV2AdminOrganizationsByOrganizationIdIntakeHubHandoffApiResponse =
  /** status 200 OK */ IntakeHubHandoffResponse;
export type GetV2AdminOrganizationsByOrganizationIdIntakeHubHandoffApiArg = {
  organizationId: string;
  userId?: string | null;
  experience?: "v2" | null;
};
export type PostV2AdminOrganizationsByOrganizationIdIntakeHubItemsAndIntakeItemIdDocumentReferencesApiResponse =
  /** status 200 OK */ AttachDocumentReferenceResponse;
export type PostV2AdminOrganizationsByOrganizationIdIntakeHubItemsAndIntakeItemIdDocumentReferencesApiArg =
  {
    organizationId: string;
    intakeItemId: string;
    userId: string;
    attachDocumentReferenceRequest: AttachDocumentReferenceRequest;
  };
export type PatchV2AdminOrganizationsByOrganizationIdIntakeHubItemsAndIntakeItemIdEvidenceApiResponse =
  /** status 200 OK */ UpdateItemEvidenceResponse;
export type PatchV2AdminOrganizationsByOrganizationIdIntakeHubItemsAndIntakeItemIdEvidenceApiArg =
  {
    organizationId: string;
    intakeItemId: string;
    userId?: string | null;
    updateItemEvidenceRequest: UpdateItemEvidenceRequest;
  };
export type PutV2AdminOrganizationsByOrganizationIdIntakeHubItemsAndIntakeItemIdSensitiveFieldsApiResponse =
  /** status 200 OK */ UpdateSensitiveFieldResponse;
export type PutV2AdminOrganizationsByOrganizationIdIntakeHubItemsAndIntakeItemIdSensitiveFieldsApiArg =
  {
    organizationId: string;
    intakeItemId: string;
    userId: string;
    updateSensitiveFieldRequest: UpdateSensitiveFieldRequest;
  };
export type PostV2AdminOrganizationsByOrganizationIdIntakeHubMaterializeApiResponse =
  /** status 200 OK */ MaterializeIntakeItemsResponse;
export type PostV2AdminOrganizationsByOrganizationIdIntakeHubMaterializeApiArg =
  {
    organizationId: string;
    userId: string;
  };
export type GetV2AdminOrganizationsByOrganizationIdIntakeHubOrgEnrollmentsApiResponse =
  /** status 200 OK */ OrganizationEnrollmentsResponse;
export type GetV2AdminOrganizationsByOrganizationIdIntakeHubOrgEnrollmentsApiArg =
  {
    organizationId: string;
  };
export type PostV2AdminOrganizationsByOrganizationIdIntakeHubOrgEnrollmentsApiResponse =
  /** status 200 OK */ OrganizationEnrollmentsResponse;
export type PostV2AdminOrganizationsByOrganizationIdIntakeHubOrgEnrollmentsApiArg =
  {
    organizationId: string;
    organizationEnrollServicesRequest: OrganizationEnrollServicesRequest;
  };
export type PostV2AdminOrganizationsByOrganizationIdIntakeHubProviderRosterApiResponse =
  /** status 200 OK */ IntakeHubProviderRosterEntryResponse3;
export type PostV2AdminOrganizationsByOrganizationIdIntakeHubProviderRosterApiArg =
  {
    organizationId: string;
    intakeHubProviderRosterAddRequest: IntakeHubProviderRosterAddRequest;
  };
export type DeleteV2AdminOrganizationsByOrganizationIdIntakeHubProviderRosterAndUserIdApiResponse =
  /** status 200 OK */ IntakeHubProviderRosterEntryResponse3;
export type DeleteV2AdminOrganizationsByOrganizationIdIntakeHubProviderRosterAndUserIdApiArg =
  {
    organizationId: string;
    userId: string;
  };
export type DeleteV2AdminOrganizationsByOrganizationIdIntakeHubVerificationApiResponse =
  /** status 200 OK */ IntakeHubJourneyStatusResponse4;
export type DeleteV2AdminOrganizationsByOrganizationIdIntakeHubVerificationApiArg =
  {
    organizationId: string;
    userId: string;
  };
export type PostV2AdminOrganizationsByOrganizationIdIntakeHubVerificationApiResponse =
  /** status 200 OK */ IntakeHubJourneyStatusResponse4;
export type PostV2AdminOrganizationsByOrganizationIdIntakeHubVerificationApiArg =
  {
    organizationId: string;
    userId: string;
  };
export type GetV2ProviderIntakeHubAgreementsApiResponse =
  /** status 200 OK */ DocusignAgreementStatusResponse;
export type GetV2ProviderIntakeHubAgreementsApiArg = void;
export type PostV2ProviderIntakeHubAgreementsRefreshApiResponse =
  /** status 200 OK */ DocusignAgreementStatusResponse;
export type PostV2ProviderIntakeHubAgreementsRefreshApiArg = void;
export type PostV2ProviderIntakeHubAgreementsSessionApiResponse =
  /** status 200 OK */ DocusignSigningSessionResponse;
export type PostV2ProviderIntakeHubAgreementsSessionApiArg = {
  docusignSigningSessionRequest: DocusignSigningSessionRequest;
};
export type GetV2ProviderIntakeHubBillingIdentitySuggestionsApiResponse =
  /** status 200 OK */ IntakeBillingIdentitySuggestionsResponse;
export type GetV2ProviderIntakeHubBillingIdentitySuggestionsApiArg = void;
export type PostV2ProviderIntakeHubBillingIdentitySuggestionsResolveApiResponse =
  /** status 200 OK */ IntakeBillingIdentitySuggestionResolveResponse;
export type PostV2ProviderIntakeHubBillingIdentitySuggestionsResolveApiArg = {
  intakeBillingIdentitySuggestionResolveRequest: IntakeBillingIdentitySuggestionResolveRequest;
};
export type PostV2ProviderIntakeHubBillingStageStatusApiResponse =
  /** status 200 OK */ IntakeBillingStageStatusResponse;
export type PostV2ProviderIntakeHubBillingStageStatusApiArg = void;
export type GetV2ProviderIntakeHubConfigApiResponse =
  /** status 200 OK */ IntakeFormConfigurationResponse2;
export type GetV2ProviderIntakeHubConfigApiArg = void;
export type PutV2ProviderIntakeHubConfigApiResponse =
  /** status 200 OK */ IntakeFormConfigurationResponse2;
export type PutV2ProviderIntakeHubConfigApiArg = {
  intakeFormConfigurationProviderUpdateRequest: IntakeFormConfigurationProviderUpdateRequest;
};
export type GetV2ProviderIntakeHubCredentialingStatusesApiResponse =
  /** status 200 OK */ PublicCredentialingStatusListResponse;
export type GetV2ProviderIntakeHubCredentialingStatusesApiArg = {
  userId?: string | null;
  payerUuid?: string | null;
  status?: IntakeCredentialingStatus2 | null;
  limit?: number;
  offset?: number;
};
export type GetV2ProviderIntakeHubCredentialingStatusesByIdByCredentialingStatusIdApiResponse =
  /** status 200 OK */ IntakeCredentialingStatusPublic2;
export type GetV2ProviderIntakeHubCredentialingStatusesByIdByCredentialingStatusIdApiArg =
  {
    credentialingStatusId: string;
  };
export type GetV2ProviderIntakeHubCredentialingStatusesByPayerUuidApiResponse =
  /** status 200 OK */ IntakeCredentialingStatusPublic2;
export type GetV2ProviderIntakeHubCredentialingStatusesByPayerUuidApiArg = {
  payerUuid: string;
  userId: string;
};
export type GetV2ProviderIntakeHubDashboardApiResponse =
  /** status 200 OK */ IntakeHubDashboardResponse;
export type GetV2ProviderIntakeHubDashboardApiArg = {
  experience?: "v2" | null;
  view?: ("individual" | "organization" | "all") | null;
  subjectUserId?: string | null;
};
export type PutV2ProviderIntakeHubDocumentFieldSuggestionsApiResponse =
  /** status 200 OK */ AcceptDocumentFieldSuggestionsResponse;
export type PutV2ProviderIntakeHubDocumentFieldSuggestionsApiArg = {
  acceptDocumentFieldSuggestionsRequest: AcceptDocumentFieldSuggestionsRequest;
};
export type GetV2ProviderIntakeHubDocumentsApiResponse =
  /** status 200 OK */ IntakeHubDocumentInventoryResponse;
export type GetV2ProviderIntakeHubDocumentsApiArg = {
  experience?: "v2" | null;
  view?: ("individual" | "organization" | "all") | null;
  subjectUserId?: string | null;
};
export type GetV2ProviderIntakeHubDocumentsDownloadApiResponse = unknown;
export type GetV2ProviderIntakeHubDocumentsDownloadApiArg = {
  experience?: "v2" | null;
  view?: ("individual" | "organization" | "all") | null;
  subjectUserId?: string | null;
};
export type PostV2ProviderIntakeHubEnrollmentsApiResponse =
  /** status 200 OK */ EnrollServicesResponse;
export type PostV2ProviderIntakeHubEnrollmentsApiArg = {
  enrollServicesRequest: EnrollServicesRequest;
};
export type PostV2ProviderIntakeHubFormApiResponse =
  /** status 200 OK */ GenerateIntakeFormResponse2;
export type PostV2ProviderIntakeHubFormApiArg = {
  generateIntakeFormRequest: GenerateIntakeFormRequest;
};
export type GetV2ProviderIntakeHubFormPayersApiResponse =
  /** status 200 OK */ IntakeFormPayerOptionsResponse;
export type GetV2ProviderIntakeHubFormPayersApiArg = void;
export type GetV2ProviderIntakeHubHandoffApiResponse =
  /** status 200 OK */ IntakeHubHandoffResponse;
export type GetV2ProviderIntakeHubHandoffApiArg = void;
export type PostV2ProviderIntakeHubItemsByIntakeItemIdDocumentReferencesApiResponse =
  /** status 200 OK */ AttachDocumentReferenceResponse;
export type PostV2ProviderIntakeHubItemsByIntakeItemIdDocumentReferencesApiArg =
  {
    intakeItemId: string;
    attachDocumentReferenceRequest: AttachDocumentReferenceRequest;
  };
export type PostV2ProviderIntakeHubItemsByIntakeItemIdDocumentsAndDocumentReferenceIdExtractionsExtractionIdFieldsFieldIdAcceptApiResponse =
  /** status 200 OK */ AcceptDocumentFieldSuggestionResponse;
export type PostV2ProviderIntakeHubItemsByIntakeItemIdDocumentsAndDocumentReferenceIdExtractionsExtractionIdFieldsFieldIdAcceptApiArg =
  {
    intakeItemId: string;
    documentReferenceId: string;
    extractionId: string;
    fieldId: string;
    acceptDocumentFieldSuggestionReviewRequest: AcceptDocumentFieldSuggestionReviewRequest;
  };
export type PatchV2ProviderIntakeHubItemsByIntakeItemIdEvidenceApiResponse =
  /** status 200 OK */ UpdateItemEvidenceResponse;
export type PatchV2ProviderIntakeHubItemsByIntakeItemIdEvidenceApiArg = {
  intakeItemId: string;
  updateItemEvidenceProviderRequest: UpdateItemEvidenceProviderRequest;
};
export type PutV2ProviderIntakeHubItemsByIntakeItemIdSensitiveFieldsApiResponse =
  /** status 200 OK */ UpdateSensitiveFieldResponse;
export type PutV2ProviderIntakeHubItemsByIntakeItemIdSensitiveFieldsApiArg = {
  intakeItemId: string;
  updateSensitiveFieldRequest: UpdateSensitiveFieldRequest;
};
export type PostV2ProviderIntakeHubMaterializeApiResponse =
  /** status 200 OK */ MaterializeIntakeItemsResponse;
export type PostV2ProviderIntakeHubMaterializeApiArg = void;
export type GetV2ProviderIntakeHubOrgServicesApiResponse =
  /** status 200 OK */ OrganizationEnrollmentsResponse;
export type GetV2ProviderIntakeHubOrgServicesApiArg = void;
export type PutV2ProviderIntakeHubOrgServicesApiResponse =
  /** status 200 OK */ OrganizationEnrollmentsResponse;
export type PutV2ProviderIntakeHubOrgServicesApiArg = {
  organizationEnrollServicesRequest: OrganizationEnrollServicesRequest;
};
export type PostV2ProviderIntakeHubProviderRosterApiResponse =
  /** status 200 OK */ IntakeHubProviderRosterEntryResponse3;
export type PostV2ProviderIntakeHubProviderRosterApiArg = {
  intakeHubProviderRosterAddRequest: IntakeHubProviderRosterAddRequest;
};
export type DeleteV2ProviderIntakeHubProviderRosterByUserIdApiResponse =
  /** status 200 OK */ IntakeHubProviderRosterEntryResponse3;
export type DeleteV2ProviderIntakeHubProviderRosterByUserIdApiArg = {
  userId: string;
};
export type IntakeItemType =
  | "information"
  | "document"
  | "action"
  | "staff_task"
  | "review";
export type IntakeRequirementContext =
  | "provider"
  | "organization"
  | "service"
  | "payer";
export type IntakeRequirementStatus = "active" | "inactive";
export type IntakeHubRequirementDefinitionResponse = {
  concept_key?: string | null;
  created_at?: string | null;
  description?: string | null;
  display_order?: number;
  item_type: IntakeItemType;
  metadata?: {
    [key: string]: any;
  };
  required_when?: {
    [key: string]: any;
  };
  requirement_context: IntakeRequirementContext;
  requirement_key: string;
  service_key?: string | null;
  status?: IntakeRequirementStatus;
  title: string;
  updated_at?: string | null;
};
export type IntakeServiceDefinitionStatus = "active" | "deprecated";
export type IntakeHubServiceDefinitionResponse = {
  created_at?: string | null;
  description?: string | null;
  display_order?: number;
  label: string;
  metadata?: {
    [key: string]: any;
  };
  service_key: string;
  status?: IntakeServiceDefinitionStatus;
  updated_at?: string | null;
};
export type IntakeHubDefinitionCatalogResponse = {
  requirements?: IntakeHubRequirementDefinitionResponse[];
  services?: IntakeHubServiceDefinitionResponse[];
};
export type ValidationErrorElement = {
  ctx?: object;
  loc: string[];
  msg: string;
  type: string;
};
export type ValidationError = ValidationErrorElement[];
export type ServerErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the server error */
  status?: number;
};
export type IntakeItemType2 =
  | "information"
  | "document"
  | "action"
  | "staff_task"
  | "review";
export type IntakeRequirementContext2 =
  | "provider"
  | "organization"
  | "service"
  | "payer";
export type IntakeRequirementStatus2 = "active" | "inactive";
export type IntakeHubRequirementDefinitionResponse2 = {
  concept_key?: string | null;
  created_at?: string | null;
  description?: string | null;
  display_order?: number;
  item_type: IntakeItemType2;
  metadata?: {
    [key: string]: any;
  };
  required_when?: {
    [key: string]: any;
  };
  requirement_context: IntakeRequirementContext2;
  requirement_key: string;
  service_key?: string | null;
  status?: IntakeRequirementStatus2;
  title: string;
  updated_at?: string | null;
};
export type IntakeItemType3 =
  | "information"
  | "document"
  | "action"
  | "staff_task"
  | "review";
export type IntakeRequirementContext3 =
  | "provider"
  | "organization"
  | "service"
  | "payer";
export type IntakeRequirementStatus3 = "active" | "inactive";
export type UpsertIntakeHubRequirementDefinitionRequest = {
  concept_key?: string | null;
  description?: string | null;
  display_order?: number;
  item_type: IntakeItemType3;
  metadata?: {
    [key: string]: any;
  };
  required_when?: {
    [key: string]: any;
  };
  requirement_context: IntakeRequirementContext3;
  service_key?: string | null;
  status?: IntakeRequirementStatus3;
  title: string;
};
export type IntakeServiceDefinitionStatus2 = "active" | "deprecated";
export type IntakeHubServiceDefinitionResponse2 = {
  created_at?: string | null;
  description?: string | null;
  display_order?: number;
  label: string;
  metadata?: {
    [key: string]: any;
  };
  service_key: string;
  status?: IntakeServiceDefinitionStatus2;
  updated_at?: string | null;
};
export type IntakeServiceDefinitionStatus3 = "active" | "deprecated";
export type UpsertIntakeHubServiceDefinitionRequest = {
  description?: string | null;
  display_order?: number;
  label: string;
  metadata?: {
    [key: string]: any;
  };
  status?: IntakeServiceDefinitionStatus3;
};
export type IntakeFleetCounts = {
  awaiting_verification?: number | null;
  credentialing_in_progress?: number;
  ehr_in_progress?: number;
  intake_incomplete?: number | null;
  total?: number;
};
export type IntakeCredentialingCounts = {
  complete?: number;
  in_progress?: number;
  not_started?: number;
  rejected?: number;
  total?: number;
};
export type IntakeVerificationCounts = {
  awaiting: number;
  incomplete: number;
  total: number;
  verified: number;
};
export type IntakeVerificationState = "awaiting" | "verified" | "incomplete";
export type IntakePracticeVerification = {
  provider_counts: IntakeVerificationCounts;
  state: IntakeVerificationState;
  submitted_at?: string | null;
  verified_at?: string | null;
};
export type IntakeFleetOrganization = {
  billing_connection_recorded?: boolean;
  credentialing?: IntakeCredentialingCounts | null;
  credentialing_updated_at?: string | null;
  last_activity_at?: string | null;
  organization_id: string;
  organization_name: string;
  selected_services?: string[] | null;
  verification?: IntakePracticeVerification | null;
};
export type IntakeFleetResponse = {
  counts?: IntakeFleetCounts | null;
  items: IntakeFleetOrganization[];
  page?: number;
  per_page?: number;
  total?: number;
  total_pages?: number;
};
export type IntakeVerificationState2 = "awaiting" | "verified" | "incomplete";
export type IntakeVerificationProvider = {
  display_name?: string | null;
  journeys_pending?: boolean;
  state: IntakeVerificationState2;
  submitted_at?: string | null;
  user_id: string;
  verified_at?: string | null;
};
export type IntakeVerificationCounts2 = {
  awaiting: number;
  incomplete: number;
  total: number;
  verified: number;
};
export type IntakePracticeVerification2 = {
  provider_counts: IntakeVerificationCounts2;
  state: IntakeVerificationState2;
  submitted_at?: string | null;
  verified_at?: string | null;
};
export type IntakeVerificationPractice = {
  organization_id: string;
  organization_name: string;
  providers: IntakeVerificationProvider[];
  verification: IntakePracticeVerification2;
};
export type IntakeVerificationQueueResponse = {
  items: IntakeVerificationPractice[];
  page?: number;
  per_page?: number;
  practice_counts: IntakeVerificationCounts2;
  total?: number;
  total_pages?: number;
};
export type IntakePayerRosterEnrollmentStatus =
  | "already_enrolled"
  | "wants_to_enroll";
export type IntakePayerPlanType =
  | "medicare"
  | "medicare_advantage"
  | "medicaid"
  | "managed_medicaid"
  | "commercial"
  | "other"
  | "automobile_medical"
  | "disability"
  | "liability_medical"
  | "title_v"
  | "tricare"
  | "veterans_affairs"
  | "workers_compensation";
export type IntakePayerRosterEntry = {
  enrollment_status?: IntakePayerRosterEnrollmentStatus;
  jotbill?: boolean;
  jotcred?: boolean;
  payer_id: string;
  payer_name: string;
  /** Explicit plan selections; null or empty means not selected. */
  plan_types?: IntakePayerPlanType[] | null;
  programs?: string[];
  ptan_required?: boolean | null;
  stedi_id?: string | null;
};
export type IntakeHubEvidenceSummaryResponse = {
  catalog_version?: string | null;
  confidence?: number | null;
  expires_at?: string | null;
  extracted_fields?: {
    [key: string]: any;
  };
  flags?: string[];
  label?: string | null;
  needs_review?: boolean;
  payer_roster?: IntakePayerRosterEntry[];
  value_preview?: string | null;
};
export type IntakeItemType4 =
  | "information"
  | "document"
  | "action"
  | "staff_task"
  | "review";
export type IntakeItemOwner = "clinician" | "practice_admin" | "jotpsych";
export type IntakeSourceRefRelationship =
  | "submitted"
  | "prefill"
  | "extracted_from"
  | "supporting"
  | "replacement"
  | "rejected";
export type IntakeSourceRefType =
  | "document_reference"
  | "provider_billing_info"
  | "jotcred_provider"
  | "billing_entity"
  | "payer"
  | "vault_secret"
  | "manual_entry";
export type IntakeHubSourceRefResponse = {
  id: string;
  label?: string | null;
  observed_at?: string | null;
  path?: string | null;
  relationship: IntakeSourceRefRelationship;
  type: IntakeSourceRefType;
};
export type IntakeItemStatus =
  | "missing"
  | "submitted"
  | "ai_flagged"
  | "in_review"
  | "accepted"
  | "expiring"
  | "needs_attention"
  | "staff_in_progress"
  | "staff_complete"
  | "not_applicable";
export type IntakeRequirementContext4 =
  | "provider"
  | "organization"
  | "service"
  | "payer";
export type IntakeVerifiedEditResponse = {
  actor_id: string;
  actor_kind: string;
  /** True when this edit sent the intake back for review. */
  cleared_verification?: boolean;
  edited_at: string;
  on_behalf_of_user_id?: string | null;
  reason: string;
  surface: string;
  verified_at: string;
};
export type IntakeHubItemResponse = {
  bucket?: string | null;
  concept_key?: string | null;
  counts_toward_progress?: boolean | null;
  created_at?: string | null;
  description?: string | null;
  display_order?: number;
  evidence_summary?: IntakeHubEvidenceSummaryResponse;
  intake_item_id?: string | null;
  is_complete?: boolean | null;
  item_type: IntakeItemType4;
  last_activity_at?: string | null;
  metadata?: {
    [key: string]: any;
  };
  missing_required_fields?: string[];
  organization_id: string;
  owner: IntakeItemOwner;
  requirement_key: string;
  satisfied_by_document_reference_id?: string | null;
  satisfied_by_document_reference_ids?: string[];
  /** Server-masked display form of each saved sensitive value. Never contains plaintext. */
  sensitive_fields_masked?: {
    [key: string]: string;
  };
  sensitive_fields_on_file?: (
    | "bank_account_number"
    | "bank_routing_number"
    | "caqh_password"
    | "caqh_username"
    | "ehr_admin_login_password"
    | "ehr_admin_login_username"
    | "portal_login_password"
    | "portal_login_username"
    | "ssn"
  )[];
  /** Decrypted saved values returned only to the authenticated provider who owns the item, within their organization. Empty for items owned by other users. */
  sensitive_fields_values?: {
    [key: string]: string;
  };
  service_ids?: string[];
  service_key?: string | null;
  source_refs?: IntakeHubSourceRefResponse[];
  status: IntakeItemStatus;
  status_changed_at?: string | null;
  subject_ref?: {
    [key: string]: any;
  } | null;
  subject_type: IntakeRequirementContext4;
  title?: string | null;
  updated_at?: string | null;
  user_id?: string | null;
  /** Reasons recorded when this item was changed after the provider's intake was verified. Populated for staff readers only. */
  verified_edits?: IntakeVerifiedEditResponse[];
};
export type IntakeHubProfileSummaryResponse = {
  complete_count: number;
  missing_count: number;
  needs_attention_count: number;
  percent_complete: number;
  total_count: number;
};
export type IntakeHubJourneyStatusResponse = {
  submitted_at?: string | null;
  verified_at?: string | null;
};
export type IntakeHubProgressPageResponse = {
  acknowledged: boolean;
  is_review: boolean;
  page_key: string;
  required_values_present: boolean[];
  section: "clinic_setup" | "your_intake";
};
export type IntakeHubProgressInputsResponse = {
  pages: IntakeHubProgressPageResponse[];
};
export type IntakeHubProviderRosterEntryResponse = {
  added_by?: string | null;
  created_at?: string | null;
  journey_status?: IntakeHubJourneyStatusResponse | null;
  journeys_pending?: boolean;
  organization_id: string;
  progress?: IntakeHubProfileSummaryResponse | null;
  progress_inputs?: IntakeHubProgressInputsResponse | null;
  status?: ("invited" | "in_progress" | "complete") | null;
  user_id: string;
};
export type IntakeFormConfigurationChangeResponse = {
  actor_id: string;
  actor_kind: string;
  changed_at: string;
  on_behalf_of_user_id?: string | null;
};
export type IntakeFormPayerSelectionRequest = {
  coverage_types?: string[];
  display_name?: string | null;
  in_network?: boolean;
  payer_key?: string | null;
  plan_types?: string[] | null;
  primary_payer_id?: string | null;
  programs?: string[];
  ptan_required?: boolean | null;
  state?: string | null;
  states?: string[];
  stedi_id?: string | null;
  wants_credentialing?: boolean;
  wants_enrollment?: boolean;
};
export type IntakeReviewAcknowledgementResponse = {
  acknowledged_at: string;
  actor_id: string;
  actor_kind: string;
  on_behalf_of_user_id?: string | null;
  page_key: string;
};
export type IntakeFormConfigurationResponse = {
  can_manage_services?: boolean;
  catalog_version: string;
  clinic_intake_started?: boolean;
  clinic_intake_submitted?: boolean;
  completed_pages?: ("F1" | "M5" | "M6" | "P6")[];
  enrolled_services?: ("jotcred" | "jotbill")[];
  is_prescriber?: boolean;
  last_change?: IntakeFormConfigurationChangeResponse | null;
  license_types?: string[];
  payers?: IntakeFormPayerSelectionRequest[];
  practice_type?: "solo" | "group";
  products: ("jotcred" | "jotbill")[];
  review_acknowledgements?: IntakeReviewAcknowledgementResponse[];
  role:
    | "clinic_manager"
    | "provider"
    | "manager_who_also_practices"
    | "physician_assistant";
};
export type GeneratedDocumentReferenceDestination = {
  field_key: string;
  kind: "document_reference";
};
export type GeneratedIntakeConfigDestination = {
  field_key: string;
  kind: "intake_config";
};
export type GeneratedIntakeEvidenceDestination = {
  field_key: string;
  kind: "intake_item_evidence";
};
export type GeneratedIntakeItemSensitiveDestination = {
  field_key:
    | "bank_account_number"
    | "bank_routing_number"
    | "caqh_password"
    | "caqh_username"
    | "ehr_admin_login_password"
    | "ehr_admin_login_username"
    | "portal_login_password"
    | "portal_login_username"
    | "ssn";
  kind: "intake_item_sensitive";
};
export type GeneratedDestinationInitialization = {
  kind: "jotcred_start";
  method: "POST" | "PUT";
  path: string;
};
export type GeneratedDestinationEndpoint = {
  method: "POST" | "PUT";
  path: string;
};
export type GeneratedJotCredBasicInfoDestination = {
  field_key: string;
  initialization: GeneratedDestinationInitialization;
  kind: "jotcred_basic_info";
  write: GeneratedDestinationEndpoint;
};
export type GeneratedProviderRosterDestination = {
  field_key: string;
  kind: "provider_roster";
};
export type GeneratedSecureCollectionDeferredDestination = {
  field_key: string;
  kind: "secure_collection_deferred";
  reason: string;
};
export type GeneratedIntakeDocumentForecastResponse = {
  detail?: string | null;
  group_key: string;
  label: string;
  order: number;
};
export type GeneratedIntakeFieldResponse = {
  condition: string;
  data_type: string;
  destination:
    | ({
        kind: "document_reference";
      } & GeneratedDocumentReferenceDestination)
    | ({
        kind: "intake_config";
      } & GeneratedIntakeConfigDestination)
    | ({
        kind: "intake_item_evidence";
      } & GeneratedIntakeEvidenceDestination)
    | ({
        kind: "intake_item_sensitive";
      } & GeneratedIntakeItemSensitiveDestination)
    | ({
        kind: "jotcred_basic_info";
      } & GeneratedJotCredBasicInfoDestination)
    | ({
        kind: "provider_roster";
      } & GeneratedProviderRosterDestination)
    | ({
        kind: "secure_collection_deferred";
      } & GeneratedSecureCollectionDeferredDestination);
  document_forecast?: GeneratedIntakeDocumentForecastResponse | null;
  field_id: string;
  field_key: string;
  gate: string;
  group_id: string;
  group_name: string;
  help_text: string;
  is_required: boolean;
  is_writable?: boolean;
  label: string;
  options?: string[];
  parent_field_key: string;
  phase: string;
  repeat_limit?: number | null;
  repeat_scope: string;
  requirement_key?: string | null;
  set_by: string;
  source_doc: string;
  view: string;
};
export type GeneratedIntakeSupportCtaResponse = {
  action: "message_specialist";
  label: string;
};
export type GeneratedIntakeHelpPanelResponse = {
  definition: string;
  key: string;
  support_cta: GeneratedIntakeSupportCtaResponse;
  title: string;
  what_goes_wrong?: string[];
  where_to_find?: string | null;
};
export type GeneratedIntakeGroupHelpResponse = {
  blurb?: string | null;
  group_id: string;
  group_name: string;
  help_panel?: GeneratedIntakeHelpPanelResponse | null;
  help_panel_key?: string | null;
};
export type GeneratedIntakeCanvasResponse = {
  canvas_key: string;
  canvas_name: string;
  canvas_type: string;
  fields?: GeneratedIntakeFieldResponse[];
  groups?: GeneratedIntakeGroupHelpResponse[];
  is_active: boolean;
  required_count: number;
  section: string;
};
export type GeneratedIntakeFormDerivedFlagsResponse = {
  has_medicaid?: boolean;
  has_medicare?: boolean;
  payer_requires_portal_login?: boolean;
  payer_requires_references?: boolean;
};
export type GenerateIntakeFormResponse = {
  canvases?: GeneratedIntakeCanvasResponse[];
  catalog_version: string;
  critical_field_count?: number;
  derived_flags: GeneratedIntakeFormDerivedFlagsResponse;
  total_field_count?: number;
  trailing_field_count?: number;
  views?: string[];
};
export type IntakeHubAggregateProviderResponse = {
  configuration: IntakeFormConfigurationResponse;
  display_name: string;
  error?: "form_unavailable" | null;
  form?: GenerateIntakeFormResponse | null;
  items?: IntakeHubItemResponse[];
  journey_status?: IntakeHubJourneyStatusResponse | null;
  membership_status: "active";
  progress: IntakeHubProfileSummaryResponse;
  user_id: string;
};
export type IntakeHubAggregateResponse = {
  omitted_provider_count?: number;
  organization_id: string;
  organization_items?: IntakeHubItemResponse[];
  page?: number;
  per_page?: number;
  profile_summary: IntakeHubProfileSummaryResponse;
  provider_roster?: IntakeHubProviderRosterEntryResponse[];
  providers?: IntakeHubAggregateProviderResponse[];
  total?: number;
  total_pages?: number;
};
export type DocusignInstrumentVersion = {
  label?: string | null;
  template_id: string;
  template_last_modified: string;
  template_name: string;
};
export type DocusignServiceElections = {
  jot_assure: boolean;
  managed_billing: boolean;
};
export type DocusignElectionEvidence = {
  envelope_record_id?: string | null;
  expected?: DocusignServiceElections | null;
  matches_current_selection?: boolean | null;
  observed?: DocusignServiceElections | null;
  observed_at?: string | null;
  requested: DocusignServiceElections;
  status:
    | "not_applicable"
    | "unknown"
    | "not_signed"
    | "unavailable"
    | "matched"
    | "mismatched";
};
export type DocusignTemplateValidation = {
  checked_at: string;
  expected_labels?: string[];
  missing_labels?: string[];
  optional_missing?: string[];
  template_id: string;
};
export type DocusignAgreementStatusResponse = {
  availability: "unavailable" | "available";
  can_sign?: boolean;
  customer_completed?: boolean;
  envelope_status?: string | null;
  instrument_versions?: DocusignInstrumentVersion[] | null;
  organization_id: string;
  package_revision?: string | null;
  recipient_status?: string | null;
  requires_agreement: boolean;
  service_elections?: DocusignElectionEvidence | null;
  template_validation?: DocusignTemplateValidation[] | null;
  unavailable_reason?:
    | (
        | "practice_not_enrolled"
        | "setup_incomplete"
        | "preparing"
        | "requires_support"
      )
    | null;
};
export type ClientErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the client error */
  status?: number;
};
export type IntakeFormConfigurationChangeResponse2 = {
  actor_id: string;
  actor_kind: string;
  changed_at: string;
  on_behalf_of_user_id?: string | null;
};
export type IntakeFormPayerSelectionRequest2 = {
  coverage_types?: string[];
  display_name?: string | null;
  in_network?: boolean;
  payer_key?: string | null;
  plan_types?: string[] | null;
  primary_payer_id?: string | null;
  programs?: string[];
  ptan_required?: boolean | null;
  state?: string | null;
  states?: string[];
  stedi_id?: string | null;
  wants_credentialing?: boolean;
  wants_enrollment?: boolean;
};
export type IntakeReviewAcknowledgementResponse2 = {
  acknowledged_at: string;
  actor_id: string;
  actor_kind: string;
  on_behalf_of_user_id?: string | null;
  page_key: string;
};
export type IntakeFormConfigurationResponse2 = {
  can_manage_services?: boolean;
  catalog_version: string;
  clinic_intake_started?: boolean;
  clinic_intake_submitted?: boolean;
  completed_pages?: ("F1" | "M5" | "M6" | "P6")[];
  enrolled_services?: ("jotcred" | "jotbill")[];
  is_prescriber?: boolean;
  last_change?: IntakeFormConfigurationChangeResponse2 | null;
  license_types?: string[];
  payers?: IntakeFormPayerSelectionRequest2[];
  practice_type?: "solo" | "group";
  products: ("jotcred" | "jotbill")[];
  review_acknowledgements?: IntakeReviewAcknowledgementResponse2[];
  role:
    | "clinic_manager"
    | "provider"
    | "manager_who_also_practices"
    | "physician_assistant";
};
export type IntakeFormConfigurationUpdateRequest = {
  completed_pages?: ("F1" | "M5" | "M6" | "P6")[];
  is_prescriber?: boolean;
  license_types?: string[];
  practice_type?: "solo" | "group";
  role:
    | "clinic_manager"
    | "provider"
    | "manager_who_also_practices"
    | "physician_assistant";
};
export type IntakeCredentialingRejectionReason =
  | "not_licensed"
  | "panel_closed"
  | "telehealth_only"
  | "out_of_service_area"
  | "other";
export type IntakeCredentialingStatus =
  | "not_started"
  | "in_progress"
  | "complete"
  | "rejected";
export type IntakeCredentialingStatusRecord = {
  created_at: string;
  id: string;
  metadata?: {
    [key: string]: any;
  };
  organization_id: string;
  payer_uuid: string;
  rejection_note?: string | null;
  rejection_reason?: IntakeCredentialingRejectionReason | null;
  status: IntakeCredentialingStatus;
  updated_at: string;
  user_id: string;
};
export type CredentialingStatusListResponse = {
  items: IntakeCredentialingStatusRecord[];
};
export type IntakeCredentialingStatus2 =
  | "not_started"
  | "in_progress"
  | "complete"
  | "rejected";
export type IntakeCredentialingRejectionReason2 =
  | "not_licensed"
  | "panel_closed"
  | "telehealth_only"
  | "out_of_service_area"
  | "other";
export type IntakeCredentialingStatus3 =
  | "not_started"
  | "in_progress"
  | "complete"
  | "rejected";
export type IntakeCredentialingStatusRecord2 = {
  created_at: string;
  id: string;
  metadata?: {
    [key: string]: any;
  };
  organization_id: string;
  payer_uuid: string;
  rejection_note?: string | null;
  rejection_reason?: IntakeCredentialingRejectionReason2 | null;
  status: IntakeCredentialingStatus3;
  updated_at: string;
  user_id: string;
};
export type IntakeCredentialingRejectionReason3 =
  | "not_licensed"
  | "panel_closed"
  | "telehealth_only"
  | "out_of_service_area"
  | "other";
export type IntakeCredentialingStatus4 =
  | "not_started"
  | "in_progress"
  | "complete"
  | "rejected";
export type CreateCredentialingStatusRequest = {
  metadata?: {
    [key: string]: any;
  };
  payer_uuid: string;
  rejection_note?: string | null;
  rejection_reason?: IntakeCredentialingRejectionReason3 | null;
  status?: IntakeCredentialingStatus4;
  user_id: string;
};
export type IntakeCredentialingRejectionReason4 =
  | "not_licensed"
  | "panel_closed"
  | "telehealth_only"
  | "out_of_service_area"
  | "other";
export type IntakeCredentialingStatus5 =
  | "not_started"
  | "in_progress"
  | "complete"
  | "rejected";
export type UpdateCredentialingStatusRequest = {
  metadata?: {
    [key: string]: any;
  } | null;
  rejection_note?: string | null;
  rejection_reason?: IntakeCredentialingRejectionReason4 | null;
  status?: IntakeCredentialingStatus5 | null;
};
export type IntakePayerRosterEnrollmentStatus2 =
  | "already_enrolled"
  | "wants_to_enroll";
export type IntakePayerPlanType2 =
  | "medicare"
  | "medicare_advantage"
  | "medicaid"
  | "managed_medicaid"
  | "commercial"
  | "other"
  | "automobile_medical"
  | "disability"
  | "liability_medical"
  | "title_v"
  | "tricare"
  | "veterans_affairs"
  | "workers_compensation";
export type IntakePayerRosterEntry2 = {
  enrollment_status?: IntakePayerRosterEnrollmentStatus2;
  jotbill?: boolean;
  jotcred?: boolean;
  payer_id: string;
  payer_name: string;
  /** Explicit plan selections; null or empty means not selected. */
  plan_types?: IntakePayerPlanType2[] | null;
  programs?: string[];
  ptan_required?: boolean | null;
  stedi_id?: string | null;
};
export type IntakeHubEvidenceSummaryResponse2 = {
  catalog_version?: string | null;
  confidence?: number | null;
  expires_at?: string | null;
  extracted_fields?: {
    [key: string]: any;
  };
  flags?: string[];
  label?: string | null;
  needs_review?: boolean;
  payer_roster?: IntakePayerRosterEntry2[];
  value_preview?: string | null;
};
export type IntakeItemType5 =
  | "information"
  | "document"
  | "action"
  | "staff_task"
  | "review";
export type IntakeItemOwner2 = "clinician" | "practice_admin" | "jotpsych";
export type IntakeSourceRefRelationship2 =
  | "submitted"
  | "prefill"
  | "extracted_from"
  | "supporting"
  | "replacement"
  | "rejected";
export type IntakeSourceRefType2 =
  | "document_reference"
  | "provider_billing_info"
  | "jotcred_provider"
  | "billing_entity"
  | "payer"
  | "vault_secret"
  | "manual_entry";
export type IntakeHubSourceRefResponse2 = {
  id: string;
  label?: string | null;
  observed_at?: string | null;
  path?: string | null;
  relationship: IntakeSourceRefRelationship2;
  type: IntakeSourceRefType2;
};
export type IntakeItemStatus2 =
  | "missing"
  | "submitted"
  | "ai_flagged"
  | "in_review"
  | "accepted"
  | "expiring"
  | "needs_attention"
  | "staff_in_progress"
  | "staff_complete"
  | "not_applicable";
export type IntakeRequirementContext5 =
  | "provider"
  | "organization"
  | "service"
  | "payer";
export type IntakeVerifiedEditResponse2 = {
  actor_id: string;
  actor_kind: string;
  /** True when this edit sent the intake back for review. */
  cleared_verification?: boolean;
  edited_at: string;
  on_behalf_of_user_id?: string | null;
  reason: string;
  surface: string;
  verified_at: string;
};
export type IntakeHubItemResponse2 = {
  bucket?: string | null;
  concept_key?: string | null;
  counts_toward_progress?: boolean | null;
  created_at?: string | null;
  description?: string | null;
  display_order?: number;
  evidence_summary?: IntakeHubEvidenceSummaryResponse2;
  intake_item_id?: string | null;
  is_complete?: boolean | null;
  item_type: IntakeItemType5;
  last_activity_at?: string | null;
  metadata?: {
    [key: string]: any;
  };
  missing_required_fields?: string[];
  organization_id: string;
  owner: IntakeItemOwner2;
  requirement_key: string;
  satisfied_by_document_reference_id?: string | null;
  satisfied_by_document_reference_ids?: string[];
  /** Server-masked display form of each saved sensitive value. Never contains plaintext. */
  sensitive_fields_masked?: {
    [key: string]: string;
  };
  sensitive_fields_on_file?: (
    | "bank_account_number"
    | "bank_routing_number"
    | "caqh_password"
    | "caqh_username"
    | "ehr_admin_login_password"
    | "ehr_admin_login_username"
    | "portal_login_password"
    | "portal_login_username"
    | "ssn"
  )[];
  /** Decrypted saved values returned only to the authenticated provider who owns the item, within their organization. Empty for items owned by other users. */
  sensitive_fields_values?: {
    [key: string]: string;
  };
  service_ids?: string[];
  service_key?: string | null;
  source_refs?: IntakeHubSourceRefResponse2[];
  status: IntakeItemStatus2;
  status_changed_at?: string | null;
  subject_ref?: {
    [key: string]: any;
  } | null;
  subject_type: IntakeRequirementContext5;
  title?: string | null;
  updated_at?: string | null;
  user_id?: string | null;
  /** Reasons recorded when this item was changed after the provider's intake was verified. Populated for staff readers only. */
  verified_edits?: IntakeVerifiedEditResponse2[];
};
export type IntakeHubClinicianResponse = {
  organization_id: string;
  user_id?: string | null;
};
export type IntakeHubDocumentPackageSummaryResponse = {
  required_upload_count: number;
  submitted_upload_count: number;
};
export type IntakeEnrollmentStatus =
  | "not_started"
  | "in_progress"
  | "submitted"
  | "active"
  | "completed"
  | "paused";
export type IntakeHubEnrollmentResponse = {
  created_at?: string | null;
  enrolled_at?: string | null;
  intake_enrollment_id?: string | null;
  metadata?: {
    [key: string]: any;
  };
  organization_id: string;
  service_key: string;
  status: IntakeEnrollmentStatus;
  updated_at?: string | null;
  user_id?: string | null;
};
export type IntakeHubJourneyStatusResponse2 = {
  submitted_at?: string | null;
  verified_at?: string | null;
};
export type IntakeHubPayerTileResponse = {
  items?: IntakeHubItemResponse2[];
  label?: string | null;
  payer_key?: string | null;
  status?: string | null;
};
export type IntakeVerificationCounts3 = {
  awaiting: number;
  incomplete: number;
  total: number;
  verified: number;
};
export type IntakeVerificationState3 = "awaiting" | "verified" | "incomplete";
export type IntakePracticeVerification3 = {
  provider_counts: IntakeVerificationCounts3;
  state: IntakeVerificationState3;
  submitted_at?: string | null;
  verified_at?: string | null;
};
export type IntakeHubProfileSummaryResponse2 = {
  complete_count: number;
  missing_count: number;
  needs_attention_count: number;
  percent_complete: number;
  total_count: number;
};
export type IntakeHubProgressPageResponse2 = {
  acknowledged: boolean;
  is_review: boolean;
  page_key: string;
  required_values_present: boolean[];
  section: "clinic_setup" | "your_intake";
};
export type IntakeHubProgressInputsResponse2 = {
  pages: IntakeHubProgressPageResponse2[];
};
export type IntakeHubProviderRosterEntryResponse2 = {
  added_by?: string | null;
  created_at?: string | null;
  journey_status?: IntakeHubJourneyStatusResponse2 | null;
  journeys_pending?: boolean;
  organization_id: string;
  progress?: IntakeHubProfileSummaryResponse2 | null;
  progress_inputs?: IntakeHubProgressInputsResponse2 | null;
  status?: ("invited" | "in_progress" | "complete") | null;
  user_id: string;
};
export type IntakeServiceDefinitionStatus4 = "active" | "deprecated";
export type IntakeHubServiceDefinitionResponse3 = {
  created_at?: string | null;
  description?: string | null;
  display_order?: number;
  label: string;
  metadata?: {
    [key: string]: any;
  };
  service_key: string;
  status?: IntakeServiceDefinitionStatus4;
  updated_at?: string | null;
};
export type IntakeHubDashboardResponse = {
  briefing_items?: IntakeHubItemResponse2[];
  clinician: IntakeHubClinicianResponse;
  document_package_summary: IntakeHubDocumentPackageSummaryResponse;
  enrollments?: IntakeHubEnrollmentResponse[];
  items?: IntakeHubItemResponse2[];
  items_by_bucket?: {
    [key: string]: IntakeHubItemResponse2[];
  };
  journey_status?: IntakeHubJourneyStatusResponse2;
  payer_tiles?: IntakeHubPayerTileResponse[];
  /** Customer-safe verification counts for the whole practice roster. */
  practice_verification?: IntakePracticeVerification3 | null;
  profile_summary: IntakeHubProfileSummaryResponse2;
  provider_roster?: IntakeHubProviderRosterEntryResponse2[];
  services?: IntakeHubServiceDefinitionResponse3[];
  verification?: IntakePracticeVerification3 | null;
};
export type DocumentReferenceSummaryResponse = {
  author_facility?: string | null;
  author_provider_name?: string | null;
  authored_at?: string | null;
  created_at: string;
  derived_via?: string | null;
  description?: string | null;
  doc_kind?: string | null;
  document_domain?: string;
  document_reference_id: string;
  effective_date?: string | null;
  encounter_id?: string | null;
  organization_id: string;
  patient_id?: string | null;
  processing_status: string;
  scope: string;
  sensitivity_level?: string | null;
  signed_at?: string | null;
  source_artifact_id?: string | null;
  source_location?: {
    [key: string]: any;
  } | null;
  supersedes_document_reference_id?: string | null;
  tags?: string[];
  title?: string | null;
  updated_at: string;
};
export type IntakeItemStatus3 =
  | "missing"
  | "submitted"
  | "ai_flagged"
  | "in_review"
  | "accepted"
  | "expiring"
  | "needs_attention"
  | "staff_in_progress"
  | "staff_complete"
  | "not_applicable";
export type IntakeHubDocumentExtractedFieldResponse = {
  key: string;
  label: string;
  requirement_key?: string | null;
  source_intake_item_id?: string | null;
  status?: IntakeItemStatus3 | null;
  value: any;
};
export type IntakeHubDocumentFieldSuggestionResponse = {
  catalog_version: string;
  confidence: number;
  current_value: string | boolean | number | number | string[] | null;
  document_kind: string;
  extraction_id: string;
  field_id: string;
  repeat_record_id?: string | null;
  target_intake_item_id: string;
  value: string | boolean | number | number | string[];
};
export type IntakeItemType6 =
  | "information"
  | "document"
  | "action"
  | "staff_task"
  | "review";
export type IntakeHubDocumentItemLinkResponse = {
  concept_key?: string | null;
  intake_item_id?: string | null;
  item_type: IntakeItemType6;
  requirement_key: string;
  service_ids?: string[];
  status: IntakeItemStatus3;
  title?: string | null;
};
export type IntakeHubDocumentInventoryItemResponse = {
  document_reference: DocumentReferenceSummaryResponse;
  extracted_fields?: IntakeHubDocumentExtractedFieldResponse[];
  field_suggestions?: IntakeHubDocumentFieldSuggestionResponse[];
  linked_items?: IntakeHubDocumentItemLinkResponse[];
  /** Raw filename of the uploaded source artifact, when the artifact recorded one. Null for documents with no artifact-side filename. */
  original_filename?: string | null;
};
export type IntakeHubDocumentInventoryResponse = {
  documents?: IntakeHubDocumentInventoryItemResponse[];
};
export type IntakeEnrollmentStatus2 =
  | "not_started"
  | "in_progress"
  | "submitted"
  | "active"
  | "completed"
  | "paused";
export type IntakeHubEnrollmentResponse2 = {
  created_at?: string | null;
  enrolled_at?: string | null;
  intake_enrollment_id?: string | null;
  metadata?: {
    [key: string]: any;
  };
  organization_id: string;
  service_key: string;
  status: IntakeEnrollmentStatus2;
  updated_at?: string | null;
  user_id?: string | null;
};
export type EnrollServicesResponse = {
  enrollments: IntakeHubEnrollmentResponse2[];
};
export type EnrollServicesRequest = {
  service_keys: string[];
};
export type GeneratedDocumentReferenceDestination2 = {
  field_key: string;
  kind: "document_reference";
};
export type GeneratedIntakeConfigDestination2 = {
  field_key: string;
  kind: "intake_config";
};
export type GeneratedIntakeEvidenceDestination2 = {
  field_key: string;
  kind: "intake_item_evidence";
};
export type GeneratedIntakeItemSensitiveDestination2 = {
  field_key:
    | "bank_account_number"
    | "bank_routing_number"
    | "caqh_password"
    | "caqh_username"
    | "ehr_admin_login_password"
    | "ehr_admin_login_username"
    | "portal_login_password"
    | "portal_login_username"
    | "ssn";
  kind: "intake_item_sensitive";
};
export type GeneratedDestinationInitialization2 = {
  kind: "jotcred_start";
  method: "POST" | "PUT";
  path: string;
};
export type GeneratedDestinationEndpoint2 = {
  method: "POST" | "PUT";
  path: string;
};
export type GeneratedJotCredBasicInfoDestination2 = {
  field_key: string;
  initialization: GeneratedDestinationInitialization2;
  kind: "jotcred_basic_info";
  write: GeneratedDestinationEndpoint2;
};
export type GeneratedProviderRosterDestination2 = {
  field_key: string;
  kind: "provider_roster";
};
export type GeneratedSecureCollectionDeferredDestination2 = {
  field_key: string;
  kind: "secure_collection_deferred";
  reason: string;
};
export type GeneratedIntakeDocumentForecastResponse2 = {
  detail?: string | null;
  group_key: string;
  label: string;
  order: number;
};
export type GeneratedIntakeFieldResponse2 = {
  condition: string;
  data_type: string;
  destination:
    | ({
        kind: "document_reference";
      } & GeneratedDocumentReferenceDestination2)
    | ({
        kind: "intake_config";
      } & GeneratedIntakeConfigDestination2)
    | ({
        kind: "intake_item_evidence";
      } & GeneratedIntakeEvidenceDestination2)
    | ({
        kind: "intake_item_sensitive";
      } & GeneratedIntakeItemSensitiveDestination2)
    | ({
        kind: "jotcred_basic_info";
      } & GeneratedJotCredBasicInfoDestination2)
    | ({
        kind: "provider_roster";
      } & GeneratedProviderRosterDestination2)
    | ({
        kind: "secure_collection_deferred";
      } & GeneratedSecureCollectionDeferredDestination2);
  document_forecast?: GeneratedIntakeDocumentForecastResponse2 | null;
  field_id: string;
  field_key: string;
  gate: string;
  group_id: string;
  group_name: string;
  help_text: string;
  is_required: boolean;
  is_writable?: boolean;
  label: string;
  options?: string[];
  parent_field_key: string;
  phase: string;
  repeat_limit?: number | null;
  repeat_scope: string;
  requirement_key?: string | null;
  set_by: string;
  source_doc: string;
  view: string;
};
export type GeneratedIntakeSupportCtaResponse2 = {
  action: "message_specialist";
  label: string;
};
export type GeneratedIntakeHelpPanelResponse2 = {
  definition: string;
  key: string;
  support_cta: GeneratedIntakeSupportCtaResponse2;
  title: string;
  what_goes_wrong?: string[];
  where_to_find?: string | null;
};
export type GeneratedIntakeGroupHelpResponse2 = {
  blurb?: string | null;
  group_id: string;
  group_name: string;
  help_panel?: GeneratedIntakeHelpPanelResponse2 | null;
  help_panel_key?: string | null;
};
export type GeneratedIntakeCanvasResponse2 = {
  canvas_key: string;
  canvas_name: string;
  canvas_type: string;
  fields?: GeneratedIntakeFieldResponse2[];
  groups?: GeneratedIntakeGroupHelpResponse2[];
  is_active: boolean;
  required_count: number;
  section: string;
};
export type GeneratedIntakeFormDerivedFlagsResponse2 = {
  has_medicaid?: boolean;
  has_medicare?: boolean;
  payer_requires_portal_login?: boolean;
  payer_requires_references?: boolean;
};
export type GenerateIntakeFormResponse2 = {
  canvases?: GeneratedIntakeCanvasResponse2[];
  catalog_version: string;
  critical_field_count?: number;
  derived_flags: GeneratedIntakeFormDerivedFlagsResponse2;
  total_field_count?: number;
  trailing_field_count?: number;
  views?: string[];
};
export type IntakeFormPayerSelectionRequest3 = {
  coverage_types?: string[];
  display_name?: string | null;
  in_network?: boolean;
  payer_key?: string | null;
  plan_types?: string[] | null;
  primary_payer_id?: string | null;
  programs?: string[];
  ptan_required?: boolean | null;
  state?: string | null;
  states?: string[];
  stedi_id?: string | null;
  wants_credentialing?: boolean;
  wants_enrollment?: boolean;
};
export type GenerateIntakeFormRequest = {
  is_prescriber?: boolean;
  license_types?: string[];
  payers?: IntakeFormPayerSelectionRequest3[];
  practice_type?: "solo" | "group";
  products?: ("jotcred" | "jotbill")[];
  role:
    | "clinic_manager"
    | "provider"
    | "manager_who_also_practices"
    | "physician_assistant";
};
export type IntakeFormPayerOptionResponse = {
  display_name: string;
  payer_key: string;
};
export type IntakeFormPayerOptionsResponse = {
  payers?: IntakeFormPayerOptionResponse[];
};
export type IntakeItemStatus4 =
  | "missing"
  | "submitted"
  | "ai_flagged"
  | "in_review"
  | "accepted"
  | "expiring"
  | "needs_attention"
  | "staff_in_progress"
  | "staff_complete"
  | "not_applicable";
export type IntakeHubHandoffChecklistItem = {
  is_complete?: boolean;
  missing_required_fields?: string[];
  requirement_key: string;
  service_ids?: string[];
  status: IntakeItemStatus4;
  title?: string | null;
};
export type IntakeHubHandoffStediStatus = {
  account_label?: string | null;
  connected?: boolean;
  last_verified_at?: string | null;
  verified?: boolean;
};
export type IntakeHubHandoffResponse = {
  checklist?: IntakeHubHandoffChecklistItem[];
  outstanding_count?: number;
  percent_complete?: number;
  ready?: boolean;
  stedi: IntakeHubHandoffStediStatus;
};
export type IntakePayerRosterEnrollmentStatus3 =
  | "already_enrolled"
  | "wants_to_enroll";
export type IntakePayerPlanType3 =
  | "medicare"
  | "medicare_advantage"
  | "medicaid"
  | "managed_medicaid"
  | "commercial"
  | "other"
  | "automobile_medical"
  | "disability"
  | "liability_medical"
  | "title_v"
  | "tricare"
  | "veterans_affairs"
  | "workers_compensation";
export type IntakePayerRosterEntry3 = {
  enrollment_status?: IntakePayerRosterEnrollmentStatus3;
  jotbill?: boolean;
  jotcred?: boolean;
  payer_id: string;
  payer_name: string;
  /** Explicit plan selections; null or empty means not selected. */
  plan_types?: IntakePayerPlanType3[] | null;
  programs?: string[];
  ptan_required?: boolean | null;
  stedi_id?: string | null;
};
export type IntakeHubEvidenceSummaryResponse3 = {
  catalog_version?: string | null;
  confidence?: number | null;
  expires_at?: string | null;
  extracted_fields?: {
    [key: string]: any;
  };
  flags?: string[];
  label?: string | null;
  needs_review?: boolean;
  payer_roster?: IntakePayerRosterEntry3[];
  value_preview?: string | null;
};
export type IntakeItemType7 =
  | "information"
  | "document"
  | "action"
  | "staff_task"
  | "review";
export type IntakeItemOwner3 = "clinician" | "practice_admin" | "jotpsych";
export type IntakeSourceRefRelationship3 =
  | "submitted"
  | "prefill"
  | "extracted_from"
  | "supporting"
  | "replacement"
  | "rejected";
export type IntakeSourceRefType3 =
  | "document_reference"
  | "provider_billing_info"
  | "jotcred_provider"
  | "billing_entity"
  | "payer"
  | "vault_secret"
  | "manual_entry";
export type IntakeHubSourceRefResponse3 = {
  id: string;
  label?: string | null;
  observed_at?: string | null;
  path?: string | null;
  relationship: IntakeSourceRefRelationship3;
  type: IntakeSourceRefType3;
};
export type IntakeItemStatus5 =
  | "missing"
  | "submitted"
  | "ai_flagged"
  | "in_review"
  | "accepted"
  | "expiring"
  | "needs_attention"
  | "staff_in_progress"
  | "staff_complete"
  | "not_applicable";
export type IntakeRequirementContext6 =
  | "provider"
  | "organization"
  | "service"
  | "payer";
export type IntakeVerifiedEditResponse3 = {
  actor_id: string;
  actor_kind: string;
  /** True when this edit sent the intake back for review. */
  cleared_verification?: boolean;
  edited_at: string;
  on_behalf_of_user_id?: string | null;
  reason: string;
  surface: string;
  verified_at: string;
};
export type IntakeHubItemResponse3 = {
  bucket?: string | null;
  concept_key?: string | null;
  counts_toward_progress?: boolean | null;
  created_at?: string | null;
  description?: string | null;
  display_order?: number;
  evidence_summary?: IntakeHubEvidenceSummaryResponse3;
  intake_item_id?: string | null;
  is_complete?: boolean | null;
  item_type: IntakeItemType7;
  last_activity_at?: string | null;
  metadata?: {
    [key: string]: any;
  };
  missing_required_fields?: string[];
  organization_id: string;
  owner: IntakeItemOwner3;
  requirement_key: string;
  satisfied_by_document_reference_id?: string | null;
  satisfied_by_document_reference_ids?: string[];
  /** Server-masked display form of each saved sensitive value. Never contains plaintext. */
  sensitive_fields_masked?: {
    [key: string]: string;
  };
  sensitive_fields_on_file?: (
    | "bank_account_number"
    | "bank_routing_number"
    | "caqh_password"
    | "caqh_username"
    | "ehr_admin_login_password"
    | "ehr_admin_login_username"
    | "portal_login_password"
    | "portal_login_username"
    | "ssn"
  )[];
  /** Decrypted saved values returned only to the authenticated provider who owns the item, within their organization. Empty for items owned by other users. */
  sensitive_fields_values?: {
    [key: string]: string;
  };
  service_ids?: string[];
  service_key?: string | null;
  source_refs?: IntakeHubSourceRefResponse3[];
  status: IntakeItemStatus5;
  status_changed_at?: string | null;
  subject_ref?: {
    [key: string]: any;
  } | null;
  subject_type: IntakeRequirementContext6;
  title?: string | null;
  updated_at?: string | null;
  user_id?: string | null;
  /** Reasons recorded when this item was changed after the provider's intake was verified. Populated for staff readers only. */
  verified_edits?: IntakeVerifiedEditResponse3[];
};
export type AttachDocumentReferenceResponse = {
  item: IntakeHubItemResponse3;
};
export type AttachDocumentReferenceRequest = {
  document_reference_id: string;
  label?: string | null;
};
export type IntakePayerRosterEnrollmentStatus4 =
  | "already_enrolled"
  | "wants_to_enroll";
export type IntakePayerPlanType4 =
  | "medicare"
  | "medicare_advantage"
  | "medicaid"
  | "managed_medicaid"
  | "commercial"
  | "other"
  | "automobile_medical"
  | "disability"
  | "liability_medical"
  | "title_v"
  | "tricare"
  | "veterans_affairs"
  | "workers_compensation";
export type IntakePayerRosterEntry4 = {
  enrollment_status?: IntakePayerRosterEnrollmentStatus4;
  jotbill?: boolean;
  jotcred?: boolean;
  payer_id: string;
  payer_name: string;
  /** Explicit plan selections; null or empty means not selected. */
  plan_types?: IntakePayerPlanType4[] | null;
  programs?: string[];
  ptan_required?: boolean | null;
  stedi_id?: string | null;
};
export type IntakeHubEvidenceSummaryResponse4 = {
  catalog_version?: string | null;
  confidence?: number | null;
  expires_at?: string | null;
  extracted_fields?: {
    [key: string]: any;
  };
  flags?: string[];
  label?: string | null;
  needs_review?: boolean;
  payer_roster?: IntakePayerRosterEntry4[];
  value_preview?: string | null;
};
export type IntakeItemType8 =
  | "information"
  | "document"
  | "action"
  | "staff_task"
  | "review";
export type IntakeItemOwner4 = "clinician" | "practice_admin" | "jotpsych";
export type IntakeSourceRefRelationship4 =
  | "submitted"
  | "prefill"
  | "extracted_from"
  | "supporting"
  | "replacement"
  | "rejected";
export type IntakeSourceRefType4 =
  | "document_reference"
  | "provider_billing_info"
  | "jotcred_provider"
  | "billing_entity"
  | "payer"
  | "vault_secret"
  | "manual_entry";
export type IntakeHubSourceRefResponse4 = {
  id: string;
  label?: string | null;
  observed_at?: string | null;
  path?: string | null;
  relationship: IntakeSourceRefRelationship4;
  type: IntakeSourceRefType4;
};
export type IntakeItemStatus6 =
  | "missing"
  | "submitted"
  | "ai_flagged"
  | "in_review"
  | "accepted"
  | "expiring"
  | "needs_attention"
  | "staff_in_progress"
  | "staff_complete"
  | "not_applicable";
export type IntakeRequirementContext7 =
  | "provider"
  | "organization"
  | "service"
  | "payer";
export type IntakeVerifiedEditResponse4 = {
  actor_id: string;
  actor_kind: string;
  /** True when this edit sent the intake back for review. */
  cleared_verification?: boolean;
  edited_at: string;
  on_behalf_of_user_id?: string | null;
  reason: string;
  surface: string;
  verified_at: string;
};
export type IntakeHubItemResponse4 = {
  bucket?: string | null;
  concept_key?: string | null;
  counts_toward_progress?: boolean | null;
  created_at?: string | null;
  description?: string | null;
  display_order?: number;
  evidence_summary?: IntakeHubEvidenceSummaryResponse4;
  intake_item_id?: string | null;
  is_complete?: boolean | null;
  item_type: IntakeItemType8;
  last_activity_at?: string | null;
  metadata?: {
    [key: string]: any;
  };
  missing_required_fields?: string[];
  organization_id: string;
  owner: IntakeItemOwner4;
  requirement_key: string;
  satisfied_by_document_reference_id?: string | null;
  satisfied_by_document_reference_ids?: string[];
  /** Server-masked display form of each saved sensitive value. Never contains plaintext. */
  sensitive_fields_masked?: {
    [key: string]: string;
  };
  sensitive_fields_on_file?: (
    | "bank_account_number"
    | "bank_routing_number"
    | "caqh_password"
    | "caqh_username"
    | "ehr_admin_login_password"
    | "ehr_admin_login_username"
    | "portal_login_password"
    | "portal_login_username"
    | "ssn"
  )[];
  /** Decrypted saved values returned only to the authenticated provider who owns the item, within their organization. Empty for items owned by other users. */
  sensitive_fields_values?: {
    [key: string]: string;
  };
  service_ids?: string[];
  service_key?: string | null;
  source_refs?: IntakeHubSourceRefResponse4[];
  status: IntakeItemStatus6;
  status_changed_at?: string | null;
  subject_ref?: {
    [key: string]: any;
  } | null;
  subject_type: IntakeRequirementContext7;
  title?: string | null;
  updated_at?: string | null;
  user_id?: string | null;
  /** Reasons recorded when this item was changed after the provider's intake was verified. Populated for staff readers only. */
  verified_edits?: IntakeVerifiedEditResponse4[];
};
export type UpdateItemEvidenceResponse = {
  item: IntakeHubItemResponse4;
};
export type IntakePayerRosterEnrollmentStatus5 =
  | "already_enrolled"
  | "wants_to_enroll";
export type IntakePayerPlanType5 =
  | "medicare"
  | "medicare_advantage"
  | "medicaid"
  | "managed_medicaid"
  | "commercial"
  | "other"
  | "automobile_medical"
  | "disability"
  | "liability_medical"
  | "title_v"
  | "tricare"
  | "veterans_affairs"
  | "workers_compensation";
export type IntakePayerRosterEntry5 = {
  enrollment_status?: IntakePayerRosterEnrollmentStatus5;
  jotbill?: boolean;
  jotcred?: boolean;
  payer_id: string;
  payer_name: string;
  /** Explicit plan selections; null or empty means not selected. */
  plan_types?: IntakePayerPlanType5[] | null;
  programs?: string[];
  ptan_required?: boolean | null;
  stedi_id?: string | null;
};
export type IntakeItemStatus7 =
  | "missing"
  | "submitted"
  | "ai_flagged"
  | "in_review"
  | "accepted"
  | "expiring"
  | "needs_attention"
  | "staff_in_progress"
  | "staff_complete"
  | "not_applicable";
export type UpdateItemEvidenceRequest = {
  catalog_version?: string | null;
  extracted_fields?: {
    [key: string]: any;
  };
  label?: string | null;
  needs_review?: boolean | null;
  note?: string | null;
  payer_roster?: IntakePayerRosterEntry5[] | null;
  status?: IntakeItemStatus7 | null;
  value_preview?: string | null;
  /** Why a verified intake is being changed. Required when the provider's intake is verified; the edit is rejected with verified_edit_reason_required without it. Stored with the change for admin review. */
  verified_edit_reason?: string | null;
};
export type UpdateSensitiveFieldResponse = {
  /** Server-masked display form of each saved sensitive value. Never contains plaintext. */
  sensitive_fields_masked?: {
    [key: string]: string;
  };
  sensitive_fields_on_file: (
    | "bank_account_number"
    | "bank_routing_number"
    | "caqh_password"
    | "caqh_username"
    | "ehr_admin_login_password"
    | "ehr_admin_login_username"
    | "portal_login_password"
    | "portal_login_username"
    | "ssn"
  )[];
  /** Decrypted saved values returned only to the authenticated provider who owns the item, within their organization. */
  sensitive_fields_values?: {
    [key: string]: string;
  };
};
export type UpdateSensitiveFieldRequest = {
  field_key:
    | "bank_account_number"
    | "bank_routing_number"
    | "caqh_password"
    | "caqh_username"
    | "ehr_admin_login_password"
    | "ehr_admin_login_username"
    | "portal_login_password"
    | "portal_login_username"
    | "ssn";
  value: string;
  /** Why a verified intake is being changed. Required when the provider's intake is verified; the edit is rejected with verified_edit_reason_required without it. Stored with the change for admin review. */
  verified_edit_reason?: string | null;
};
export type IntakePayerRosterEnrollmentStatus6 =
  | "already_enrolled"
  | "wants_to_enroll";
export type IntakePayerPlanType6 =
  | "medicare"
  | "medicare_advantage"
  | "medicaid"
  | "managed_medicaid"
  | "commercial"
  | "other"
  | "automobile_medical"
  | "disability"
  | "liability_medical"
  | "title_v"
  | "tricare"
  | "veterans_affairs"
  | "workers_compensation";
export type IntakePayerRosterEntry6 = {
  enrollment_status?: IntakePayerRosterEnrollmentStatus6;
  jotbill?: boolean;
  jotcred?: boolean;
  payer_id: string;
  payer_name: string;
  /** Explicit plan selections; null or empty means not selected. */
  plan_types?: IntakePayerPlanType6[] | null;
  programs?: string[];
  ptan_required?: boolean | null;
  stedi_id?: string | null;
};
export type IntakeHubEvidenceSummaryResponse5 = {
  catalog_version?: string | null;
  confidence?: number | null;
  expires_at?: string | null;
  extracted_fields?: {
    [key: string]: any;
  };
  flags?: string[];
  label?: string | null;
  needs_review?: boolean;
  payer_roster?: IntakePayerRosterEntry6[];
  value_preview?: string | null;
};
export type IntakeItemType9 =
  | "information"
  | "document"
  | "action"
  | "staff_task"
  | "review";
export type IntakeItemOwner5 = "clinician" | "practice_admin" | "jotpsych";
export type IntakeSourceRefRelationship5 =
  | "submitted"
  | "prefill"
  | "extracted_from"
  | "supporting"
  | "replacement"
  | "rejected";
export type IntakeSourceRefType5 =
  | "document_reference"
  | "provider_billing_info"
  | "jotcred_provider"
  | "billing_entity"
  | "payer"
  | "vault_secret"
  | "manual_entry";
export type IntakeHubSourceRefResponse5 = {
  id: string;
  label?: string | null;
  observed_at?: string | null;
  path?: string | null;
  relationship: IntakeSourceRefRelationship5;
  type: IntakeSourceRefType5;
};
export type IntakeItemStatus8 =
  | "missing"
  | "submitted"
  | "ai_flagged"
  | "in_review"
  | "accepted"
  | "expiring"
  | "needs_attention"
  | "staff_in_progress"
  | "staff_complete"
  | "not_applicable";
export type IntakeRequirementContext8 =
  | "provider"
  | "organization"
  | "service"
  | "payer";
export type IntakeVerifiedEditResponse5 = {
  actor_id: string;
  actor_kind: string;
  /** True when this edit sent the intake back for review. */
  cleared_verification?: boolean;
  edited_at: string;
  on_behalf_of_user_id?: string | null;
  reason: string;
  surface: string;
  verified_at: string;
};
export type IntakeHubItemResponse5 = {
  bucket?: string | null;
  concept_key?: string | null;
  counts_toward_progress?: boolean | null;
  created_at?: string | null;
  description?: string | null;
  display_order?: number;
  evidence_summary?: IntakeHubEvidenceSummaryResponse5;
  intake_item_id?: string | null;
  is_complete?: boolean | null;
  item_type: IntakeItemType9;
  last_activity_at?: string | null;
  metadata?: {
    [key: string]: any;
  };
  missing_required_fields?: string[];
  organization_id: string;
  owner: IntakeItemOwner5;
  requirement_key: string;
  satisfied_by_document_reference_id?: string | null;
  satisfied_by_document_reference_ids?: string[];
  /** Server-masked display form of each saved sensitive value. Never contains plaintext. */
  sensitive_fields_masked?: {
    [key: string]: string;
  };
  sensitive_fields_on_file?: (
    | "bank_account_number"
    | "bank_routing_number"
    | "caqh_password"
    | "caqh_username"
    | "ehr_admin_login_password"
    | "ehr_admin_login_username"
    | "portal_login_password"
    | "portal_login_username"
    | "ssn"
  )[];
  /** Decrypted saved values returned only to the authenticated provider who owns the item, within their organization. Empty for items owned by other users. */
  sensitive_fields_values?: {
    [key: string]: string;
  };
  service_ids?: string[];
  service_key?: string | null;
  source_refs?: IntakeHubSourceRefResponse5[];
  status: IntakeItemStatus8;
  status_changed_at?: string | null;
  subject_ref?: {
    [key: string]: any;
  } | null;
  subject_type: IntakeRequirementContext8;
  title?: string | null;
  updated_at?: string | null;
  user_id?: string | null;
  /** Reasons recorded when this item was changed after the provider's intake was verified. Populated for staff readers only. */
  verified_edits?: IntakeVerifiedEditResponse5[];
};
export type MaterializeIntakeItemsResponse = {
  items?: IntakeHubItemResponse5[];
};
export type IntakeEnrollmentStatus3 =
  | "not_started"
  | "in_progress"
  | "submitted"
  | "active"
  | "completed"
  | "paused";
export type IntakeHubEnrollmentResponse3 = {
  created_at?: string | null;
  enrolled_at?: string | null;
  intake_enrollment_id?: string | null;
  metadata?: {
    [key: string]: any;
  };
  organization_id: string;
  service_key: string;
  status: IntakeEnrollmentStatus3;
  updated_at?: string | null;
  user_id?: string | null;
};
export type OrganizationEnrollmentsResponse = {
  addons?: string[];
  agreement_selections_locked?: boolean;
  billing_tier?: ("managed" | "self_pay") | null;
  can_manage_services?: boolean;
  derived_from_providers?: boolean;
  enrollments?: IntakeHubEnrollmentResponse3[];
  failed_user_ids?: string[];
  reconciled_user_ids?: string[];
  requested_at?: string | null;
  requested_by?: string | null;
  requested_by_kind?: string | null;
  service_keys?: string[];
};
export type OrganizationEnrollServicesRequest = {
  addons?: ("jotassure" | "ehr_migration")[];
  billing_tier?: ("managed" | "self_pay") | null;
  confirm_remove?: boolean;
  service_keys: string[];
};
export type IntakeHubJourneyStatusResponse3 = {
  submitted_at?: string | null;
  verified_at?: string | null;
};
export type IntakeHubProfileSummaryResponse3 = {
  complete_count: number;
  missing_count: number;
  needs_attention_count: number;
  percent_complete: number;
  total_count: number;
};
export type IntakeHubProgressPageResponse3 = {
  acknowledged: boolean;
  is_review: boolean;
  page_key: string;
  required_values_present: boolean[];
  section: "clinic_setup" | "your_intake";
};
export type IntakeHubProgressInputsResponse3 = {
  pages: IntakeHubProgressPageResponse3[];
};
export type IntakeHubProviderRosterEntryResponse3 = {
  added_by?: string | null;
  created_at?: string | null;
  journey_status?: IntakeHubJourneyStatusResponse3 | null;
  journeys_pending?: boolean;
  organization_id: string;
  progress?: IntakeHubProfileSummaryResponse3 | null;
  progress_inputs?: IntakeHubProgressInputsResponse3 | null;
  status?: ("invited" | "in_progress" | "complete") | null;
  user_id: string;
};
export type IntakeHubProviderRosterAddRequest = {
  user_id: string;
};
export type IntakeHubJourneyStatusResponse4 = {
  submitted_at?: string | null;
  verified_at?: string | null;
};
export type DocusignSigningSessionResponse = {
  environment: "demo" | "production";
  integration_key: string;
  organization_id: string;
  package_revision: string;
  recipient_view_url: string;
  signing_origin: string;
};
export type DocusignSigningSessionRequest = {
  return_url: string;
};
export type IntakeBillingIdentitySuggestionResponse = {
  /** Catalog address part for billing_address (line_1, line_2, city, state, zip); null for other fields */
  address_part?: string | null;
  /** Billing identity form field the value fills */
  billing_field: "tax_id" | "legal_name" | "billing_address";
  confidence: number;
  document_kind: string;
  document_reference_id: string;
  extraction_id: string;
  /** Catalog field the extraction proposed */
  field_id: string;
  uploaded_at?: string | null;
  value: string | boolean | number | number | string[];
};
export type IntakeBillingIdentitySuggestionsResponse = {
  suggestions?: IntakeBillingIdentitySuggestionResponse[];
};
export type IntakeBillingIdentitySuggestionResolveResponse = {
  resolved: boolean;
};
export type IntakeBillingIdentitySuggestionResolveRequest = {
  document_reference_id: string;
  extraction_id: string;
  field_id: string;
  outcome: "accepted" | "dismissed";
};
export type IntakeBillingStageStepsResponse = {
  facility_count: number;
  /** The default billing identity is synced to Stedi. */
  identity_synced: boolean;
  /** Payer-roster picks marked for JotBill. */
  picked_payer_count: number;
  /** Picks Stedi takes claims for: no claims enrollment needed, or a claims enrollment submitted on the default identity. */
  ready_payer_count: number;
  stedi_connected: boolean;
};
export type IntakeBillingStageStatusResponse = {
  /** Stedi connected, default identity synced, at least one facility, and at least one ready payer. */
  complete: boolean;
  /** When the stage last became complete. */
  completed_at?: string | null;
  /** When a practice admin first opened the stage. */
  started_at?: string | null;
  steps: IntakeBillingStageStepsResponse;
};
export type IntakeFormConfigurationProviderUpdateRequest = {
  completed_pages?: ("F1" | "M5" | "M6" | "P6")[];
  is_prescriber?: boolean;
  license_types?: string[];
  practice_type?: "solo" | "group";
  role:
    | "clinic_manager"
    | "provider"
    | "manager_who_also_practices"
    | "physician_assistant";
};
export type IntakeCredentialingRejectionReason5 =
  | "not_licensed"
  | "panel_closed"
  | "telehealth_only"
  | "out_of_service_area"
  | "other";
export type IntakeCredentialingStatus6 =
  | "not_started"
  | "in_progress"
  | "complete"
  | "rejected";
export type IntakeCredentialingStatusPublic = {
  created_at: string;
  id: string;
  organization_id: string;
  payer_uuid: string;
  rejection_reason?: IntakeCredentialingRejectionReason5 | null;
  status: IntakeCredentialingStatus6;
  updated_at: string;
  user_id: string;
};
export type PublicCredentialingStatusListResponse = {
  items: IntakeCredentialingStatusPublic[];
};
export type IntakeCredentialingRejectionReason6 =
  | "not_licensed"
  | "panel_closed"
  | "telehealth_only"
  | "out_of_service_area"
  | "other";
export type IntakeCredentialingStatus7 =
  | "not_started"
  | "in_progress"
  | "complete"
  | "rejected";
export type IntakeCredentialingStatusPublic2 = {
  created_at: string;
  id: string;
  organization_id: string;
  payer_uuid: string;
  rejection_reason?: IntakeCredentialingRejectionReason6 | null;
  status: IntakeCredentialingStatus7;
  updated_at: string;
  user_id: string;
};
export type IntakePayerRosterEnrollmentStatus7 =
  | "already_enrolled"
  | "wants_to_enroll";
export type IntakePayerPlanType7 =
  | "medicare"
  | "medicare_advantage"
  | "medicaid"
  | "managed_medicaid"
  | "commercial"
  | "other"
  | "automobile_medical"
  | "disability"
  | "liability_medical"
  | "title_v"
  | "tricare"
  | "veterans_affairs"
  | "workers_compensation";
export type IntakePayerRosterEntry7 = {
  enrollment_status?: IntakePayerRosterEnrollmentStatus7;
  jotbill?: boolean;
  jotcred?: boolean;
  payer_id: string;
  payer_name: string;
  /** Explicit plan selections; null or empty means not selected. */
  plan_types?: IntakePayerPlanType7[] | null;
  programs?: string[];
  ptan_required?: boolean | null;
  stedi_id?: string | null;
};
export type IntakeHubEvidenceSummaryResponse6 = {
  catalog_version?: string | null;
  confidence?: number | null;
  expires_at?: string | null;
  extracted_fields?: {
    [key: string]: any;
  };
  flags?: string[];
  label?: string | null;
  needs_review?: boolean;
  payer_roster?: IntakePayerRosterEntry7[];
  value_preview?: string | null;
};
export type IntakeItemType10 =
  | "information"
  | "document"
  | "action"
  | "staff_task"
  | "review";
export type IntakeItemOwner6 = "clinician" | "practice_admin" | "jotpsych";
export type IntakeSourceRefRelationship6 =
  | "submitted"
  | "prefill"
  | "extracted_from"
  | "supporting"
  | "replacement"
  | "rejected";
export type IntakeSourceRefType6 =
  | "document_reference"
  | "provider_billing_info"
  | "jotcred_provider"
  | "billing_entity"
  | "payer"
  | "vault_secret"
  | "manual_entry";
export type IntakeHubSourceRefResponse6 = {
  id: string;
  label?: string | null;
  observed_at?: string | null;
  path?: string | null;
  relationship: IntakeSourceRefRelationship6;
  type: IntakeSourceRefType6;
};
export type IntakeItemStatus9 =
  | "missing"
  | "submitted"
  | "ai_flagged"
  | "in_review"
  | "accepted"
  | "expiring"
  | "needs_attention"
  | "staff_in_progress"
  | "staff_complete"
  | "not_applicable";
export type IntakeRequirementContext9 =
  | "provider"
  | "organization"
  | "service"
  | "payer";
export type IntakeVerifiedEditResponse6 = {
  actor_id: string;
  actor_kind: string;
  /** True when this edit sent the intake back for review. */
  cleared_verification?: boolean;
  edited_at: string;
  on_behalf_of_user_id?: string | null;
  reason: string;
  surface: string;
  verified_at: string;
};
export type IntakeHubItemResponse6 = {
  bucket?: string | null;
  concept_key?: string | null;
  counts_toward_progress?: boolean | null;
  created_at?: string | null;
  description?: string | null;
  display_order?: number;
  evidence_summary?: IntakeHubEvidenceSummaryResponse6;
  intake_item_id?: string | null;
  is_complete?: boolean | null;
  item_type: IntakeItemType10;
  last_activity_at?: string | null;
  metadata?: {
    [key: string]: any;
  };
  missing_required_fields?: string[];
  organization_id: string;
  owner: IntakeItemOwner6;
  requirement_key: string;
  satisfied_by_document_reference_id?: string | null;
  satisfied_by_document_reference_ids?: string[];
  /** Server-masked display form of each saved sensitive value. Never contains plaintext. */
  sensitive_fields_masked?: {
    [key: string]: string;
  };
  sensitive_fields_on_file?: (
    | "bank_account_number"
    | "bank_routing_number"
    | "caqh_password"
    | "caqh_username"
    | "ehr_admin_login_password"
    | "ehr_admin_login_username"
    | "portal_login_password"
    | "portal_login_username"
    | "ssn"
  )[];
  /** Decrypted saved values returned only to the authenticated provider who owns the item, within their organization. Empty for items owned by other users. */
  sensitive_fields_values?: {
    [key: string]: string;
  };
  service_ids?: string[];
  service_key?: string | null;
  source_refs?: IntakeHubSourceRefResponse6[];
  status: IntakeItemStatus9;
  status_changed_at?: string | null;
  subject_ref?: {
    [key: string]: any;
  } | null;
  subject_type: IntakeRequirementContext9;
  title?: string | null;
  updated_at?: string | null;
  user_id?: string | null;
  /** Reasons recorded when this item was changed after the provider's intake was verified. Populated for staff readers only. */
  verified_edits?: IntakeVerifiedEditResponse6[];
};
export type AcceptDocumentFieldSuggestionResult = {
  document_reference_id: string;
  extraction_id: string;
  field_id: string;
  intake_item_id: string;
  item?: IntakeHubItemResponse6 | null;
  outcome: "accepted" | "conflict" | "not_found";
  repeat_record_id?: string | null;
};
export type AcceptDocumentFieldSuggestionsResponse = {
  results: AcceptDocumentFieldSuggestionResult[];
};
export type AcceptDocumentFieldSuggestionRequest = {
  document_reference_id: string;
  expected_current_value: string | boolean | number | number | string[] | null;
  extraction_id: string;
  field_id: string;
  intake_item_id: string;
  repeat_record_id?: string | null;
};
export type AcceptDocumentFieldSuggestionsRequest = {
  suggestions: AcceptDocumentFieldSuggestionRequest[];
};
export type IntakePayerRosterEnrollmentStatus8 =
  | "already_enrolled"
  | "wants_to_enroll";
export type IntakePayerPlanType8 =
  | "medicare"
  | "medicare_advantage"
  | "medicaid"
  | "managed_medicaid"
  | "commercial"
  | "other"
  | "automobile_medical"
  | "disability"
  | "liability_medical"
  | "title_v"
  | "tricare"
  | "veterans_affairs"
  | "workers_compensation";
export type IntakePayerRosterEntry8 = {
  enrollment_status?: IntakePayerRosterEnrollmentStatus8;
  jotbill?: boolean;
  jotcred?: boolean;
  payer_id: string;
  payer_name: string;
  /** Explicit plan selections; null or empty means not selected. */
  plan_types?: IntakePayerPlanType8[] | null;
  programs?: string[];
  ptan_required?: boolean | null;
  stedi_id?: string | null;
};
export type IntakeHubEvidenceSummaryResponse7 = {
  catalog_version?: string | null;
  confidence?: number | null;
  expires_at?: string | null;
  extracted_fields?: {
    [key: string]: any;
  };
  flags?: string[];
  label?: string | null;
  needs_review?: boolean;
  payer_roster?: IntakePayerRosterEntry8[];
  value_preview?: string | null;
};
export type IntakeItemType11 =
  | "information"
  | "document"
  | "action"
  | "staff_task"
  | "review";
export type IntakeItemOwner7 = "clinician" | "practice_admin" | "jotpsych";
export type IntakeSourceRefRelationship7 =
  | "submitted"
  | "prefill"
  | "extracted_from"
  | "supporting"
  | "replacement"
  | "rejected";
export type IntakeSourceRefType7 =
  | "document_reference"
  | "provider_billing_info"
  | "jotcred_provider"
  | "billing_entity"
  | "payer"
  | "vault_secret"
  | "manual_entry";
export type IntakeHubSourceRefResponse7 = {
  id: string;
  label?: string | null;
  observed_at?: string | null;
  path?: string | null;
  relationship: IntakeSourceRefRelationship7;
  type: IntakeSourceRefType7;
};
export type IntakeItemStatus10 =
  | "missing"
  | "submitted"
  | "ai_flagged"
  | "in_review"
  | "accepted"
  | "expiring"
  | "needs_attention"
  | "staff_in_progress"
  | "staff_complete"
  | "not_applicable";
export type IntakeRequirementContext10 =
  | "provider"
  | "organization"
  | "service"
  | "payer";
export type IntakeVerifiedEditResponse7 = {
  actor_id: string;
  actor_kind: string;
  /** True when this edit sent the intake back for review. */
  cleared_verification?: boolean;
  edited_at: string;
  on_behalf_of_user_id?: string | null;
  reason: string;
  surface: string;
  verified_at: string;
};
export type IntakeHubItemResponse7 = {
  bucket?: string | null;
  concept_key?: string | null;
  counts_toward_progress?: boolean | null;
  created_at?: string | null;
  description?: string | null;
  display_order?: number;
  evidence_summary?: IntakeHubEvidenceSummaryResponse7;
  intake_item_id?: string | null;
  is_complete?: boolean | null;
  item_type: IntakeItemType11;
  last_activity_at?: string | null;
  metadata?: {
    [key: string]: any;
  };
  missing_required_fields?: string[];
  organization_id: string;
  owner: IntakeItemOwner7;
  requirement_key: string;
  satisfied_by_document_reference_id?: string | null;
  satisfied_by_document_reference_ids?: string[];
  /** Server-masked display form of each saved sensitive value. Never contains plaintext. */
  sensitive_fields_masked?: {
    [key: string]: string;
  };
  sensitive_fields_on_file?: (
    | "bank_account_number"
    | "bank_routing_number"
    | "caqh_password"
    | "caqh_username"
    | "ehr_admin_login_password"
    | "ehr_admin_login_username"
    | "portal_login_password"
    | "portal_login_username"
    | "ssn"
  )[];
  /** Decrypted saved values returned only to the authenticated provider who owns the item, within their organization. Empty for items owned by other users. */
  sensitive_fields_values?: {
    [key: string]: string;
  };
  service_ids?: string[];
  service_key?: string | null;
  source_refs?: IntakeHubSourceRefResponse7[];
  status: IntakeItemStatus10;
  status_changed_at?: string | null;
  subject_ref?: {
    [key: string]: any;
  } | null;
  subject_type: IntakeRequirementContext10;
  title?: string | null;
  updated_at?: string | null;
  user_id?: string | null;
  /** Reasons recorded when this item was changed after the provider's intake was verified. Populated for staff readers only. */
  verified_edits?: IntakeVerifiedEditResponse7[];
};
export type AcceptDocumentFieldSuggestionResponse = {
  item: IntakeHubItemResponse7;
};
export type AcceptDocumentFieldSuggestionReviewRequest = {
  expected_current_value: string | boolean | number | number | string[] | null;
  repeat_record_id?: string | null;
};
export type IntakePayerRosterEnrollmentStatus9 =
  | "already_enrolled"
  | "wants_to_enroll";
export type IntakePayerPlanType9 =
  | "medicare"
  | "medicare_advantage"
  | "medicaid"
  | "managed_medicaid"
  | "commercial"
  | "other"
  | "automobile_medical"
  | "disability"
  | "liability_medical"
  | "title_v"
  | "tricare"
  | "veterans_affairs"
  | "workers_compensation";
export type IntakePayerRosterEntry9 = {
  enrollment_status?: IntakePayerRosterEnrollmentStatus9;
  jotbill?: boolean;
  jotcred?: boolean;
  payer_id: string;
  payer_name: string;
  /** Explicit plan selections; null or empty means not selected. */
  plan_types?: IntakePayerPlanType9[] | null;
  programs?: string[];
  ptan_required?: boolean | null;
  stedi_id?: string | null;
};
export type IntakeItemStatus11 =
  | "missing"
  | "submitted"
  | "ai_flagged"
  | "in_review"
  | "accepted"
  | "expiring"
  | "needs_attention"
  | "staff_in_progress"
  | "staff_complete"
  | "not_applicable";
export type UpdateItemEvidenceProviderRequest = {
  catalog_version?: string | null;
  extracted_fields?: {
    [key: string]: any;
  };
  label?: string | null;
  needs_review?: boolean | null;
  note?: string | null;
  /** The practice's complete payer roster. This row is shared by the whole practice and a write replaces it, so send every payer that should remain -- any payer omitted here is removed. An entry with no enrollment_status is recorded as wants_to_enroll when a provider writes it. */
  payer_roster?: IntakePayerRosterEntry9[] | null;
  status?: IntakeItemStatus11 | null;
  value_preview?: string | null;
  /** Why a verified intake is being changed. Required when the provider's intake is verified; the edit is rejected with verified_edit_reason_required without it. Stored with the change for admin review. */
  verified_edit_reason?: string | null;
};
